'use strict';

var _get = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/get.js");
var _inherits = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _objectDestructuringEmpty = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/objectDestructuringEmpty.js");
var _toArray = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/toArray.js");
var _toConsumableArray = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _classCallCheck = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/createClass.js");
var _objectWithoutProperties = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _defineProperty = require("/builds/corpoapps/websites/islandsofinsight/ioi-frontend/node_modules/@babel/runtime/helpers/defineProperty.js");
var _excluded = ["attrX", "attrY", "attrScale", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"],
  _excluded2 = ["keyframes", "restDelta", "restSpeed"],
  _excluded3 = ["autoplay", "delay", "driver", "keyframes", "type", "repeat", "repeatDelay", "repeatType", "onPlay", "onStop", "onComplete", "onUpdate"],
  _excluded4 = ["onUpdate", "onComplete"],
  _excluded5 = ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from", "elapsed"],
  _excluded6 = ["transitionEnd", "transition"],
  _excluded7 = ["transition", "transitionEnd"],
  _excluded8 = ["willChange"],
  _excluded9 = ["children"],
  _excluded10 = ["transition", "transitionEnd"],
  _excluded11 = ["defaultTransition"],
  _excluded12 = ["delay", "times", "type"],
  _excluded13 = ["container"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var isBrowser = typeof document !== "undefined";
function isRefObject(ref) {
  return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

/**
 * Decides if the supplied variable is variant label
 */
function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
}
function isAnimationControls(v) {
  return typeof v === "object" && typeof v.start === "function";
}
var variantPriorityOrder = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"];
var variantProps = ["initial"].concat(variantPriorityOrder);
function isControllingVariants(props) {
  return isAnimationControls(props.animate) || variantProps.some(function (name) {
    return isVariantLabel(props[name]);
  });
}
function isVariantNode(props) {
  return Boolean(isControllingVariants(props) || props.variants);
}
var featureProps = {
  animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
var featureDefinitions = {};
var _loop = function _loop(key) {
  featureDefinitions[key] = {
    isEnabled: function isEnabled(props) {
      return featureProps[key].some(function (name) {
        return !!props[name];
      });
    }
  };
};
for (var key in featureProps) {
  _loop(key);
}
var scaleCorrectors = {};
function addScaleCorrector(correctors) {
  Object.assign(scaleCorrectors, correctors);
}

/**
 * Generate a list of every possible transform key.
 */
var transformPropOrder = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"];
/**
 * A quick lookup for transform props.
 */
var transformProps = new Set(transformPropOrder);
function isForcedMotionValue(key, _ref) {
  var layout = _ref.layout,
    layoutId = _ref.layoutId;
  return transformProps.has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!scaleCorrectors[key] || key === "opacity");
}
var isMotionValue = function isMotionValue(value) {
  return Boolean(value && value.getVelocity);
};
var translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
var numTransforms = transformPropOrder.length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */
function buildTransform(transform, _ref2, transformIsDefault, transformTemplate) {
  var _ref2$enableHardwareA = _ref2.enableHardwareAcceleration,
    enableHardwareAcceleration = _ref2$enableHardwareA === void 0 ? true : _ref2$enableHardwareA,
    _ref2$allowTransformN = _ref2.allowTransformNone,
    allowTransformNone = _ref2$allowTransformN === void 0 ? true : _ref2$allowTransformN;
  // The transform string we're going to build into.
  var transformString = "";
  /**
   * Loop over all possible transforms in order, adding the ones that
   * are present to the transform string.
   */
  for (var i = 0; i < numTransforms; i++) {
    var _key = transformPropOrder[i];
    if (transform[_key] !== undefined) {
      var transformName = translateAlias[_key] || _key;
      transformString += "".concat(transformName, "(").concat(transform[_key], ") ");
    }
  }
  if (enableHardwareAcceleration && !transform.z) {
    transformString += "translateZ(0)";
  }
  transformString = transformString.trim();
  // If we have a custom `transform` template, pass our transform values and
  // generated transformString to that before returning
  if (transformTemplate) {
    transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = "none";
  }
  return transformString;
}
var checkStringStartsWith = function checkStringStartsWith(token) {
  return function (key) {
    return typeof key === "string" && key.startsWith(token);
  };
};
var isCSSVariableName = checkStringStartsWith("--");
var isCSSVariableToken = checkStringStartsWith("var(--");
var cssVariableRegex = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;

/**
 * Provided a value and a ValueType, returns the value as that value type.
 */
var getValueAsType = function getValueAsType(value, type) {
  return type && typeof value === "number" ? type.transform(value) : value;
};
var clamp = function clamp(min, max, v) {
  return Math.min(Math.max(v, min), max);
};
var number = {
  test: function test(v) {
    return typeof v === "number";
  },
  parse: parseFloat,
  transform: function transform(v) {
    return v;
  }
};
var alpha = _objectSpread(_objectSpread({}, number), {}, {
  transform: function transform(v) {
    return clamp(0, 1, v);
  }
});
var scale = _objectSpread(_objectSpread({}, number), {}, {
  default: 1
});

/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var sanitize = function sanitize(v) {
  return Math.round(v * 100000) / 100000;
};
var floatRegex = /(-)?([\d]*\.?[\d])+/g;
var colorRegex = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function isString(v) {
  return typeof v === "string";
}
var createUnitType = function createUnitType(unit) {
  return {
    test: function test(v) {
      return isString(v) && v.endsWith(unit) && v.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function transform(v) {
      return "".concat(v).concat(unit);
    }
  };
};
var degrees = createUnitType("deg");
var percent = createUnitType("%");
var px = createUnitType("px");
var vh = createUnitType("vh");
var vw = createUnitType("vw");
var progressPercentage = _objectSpread(_objectSpread({}, percent), {}, {
  parse: function parse(v) {
    return percent.parse(v) / 100;
  },
  transform: function transform(v) {
    return percent.transform(v * 100);
  }
});
var int = _objectSpread(_objectSpread({}, number), {}, {
  transform: Math.round
});
var numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Transform props
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale: scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  // Misc
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};
function buildHTMLStyles(state, latestValues, options, transformTemplate) {
  var style = state.style,
    vars = state.vars,
    transform = state.transform,
    transformOrigin = state.transformOrigin;
  // Track whether we encounter any transform or transformOrigin values.
  var hasTransform = false;
  var hasTransformOrigin = false;
  // Does the calculated transform essentially equal "none"?
  var transformIsNone = true;
  /**
   * Loop over all our latest animated values and decide whether to handle them
   * as a style or CSS variable.
   *
   * Transforms and transform origins are kept seperately for further processing.
   */
  for (var _key2 in latestValues) {
    var value = latestValues[_key2];
    /**
     * If this is a CSS variable we don't do any further processing.
     */
    if (isCSSVariableName(_key2)) {
      vars[_key2] = value;
      continue;
    }
    // Convert the value to its default value type, ie 0 -> "0px"
    var valueType = numberValueTypes[_key2];
    var valueAsType = getValueAsType(value, valueType);
    if (transformProps.has(_key2)) {
      // If this is a transform, flag to enable further transform processing
      hasTransform = true;
      transform[_key2] = valueAsType;
      // If we already know we have a non-default transform, early return
      if (!transformIsNone) continue;
      // Otherwise check to see if this is a default transform
      if (value !== (valueType.default || 0)) transformIsNone = false;
    } else if (_key2.startsWith("origin")) {
      // If this is a transform origin, flag and enable further transform-origin processing
      hasTransformOrigin = true;
      transformOrigin[_key2] = valueAsType;
    } else {
      style[_key2] = valueAsType;
    }
  }
  if (!latestValues.transform) {
    if (hasTransform || transformTemplate) {
      style.transform = buildTransform(state.transform, options, transformIsNone, transformTemplate);
    } else if (style.transform) {
      /**
       * If we have previously created a transform but currently don't have any,
       * reset transform style to none.
       */
      style.transform = "none";
    }
  }
  /**
   * Build a transformOrigin style. Uses the same defaults as the browser for
   * undefined origins.
   */
  if (hasTransformOrigin) {
    var _transformOrigin$orig = transformOrigin.originX,
      originX = _transformOrigin$orig === void 0 ? "50%" : _transformOrigin$orig,
      _transformOrigin$orig2 = transformOrigin.originY,
      originY = _transformOrigin$orig2 === void 0 ? "50%" : _transformOrigin$orig2,
      _transformOrigin$orig3 = transformOrigin.originZ,
      originZ = _transformOrigin$orig3 === void 0 ? 0 : _transformOrigin$orig3;
    style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
  }
}
function calcOrigin(origin, offset, size) {
  return typeof origin === "string" ? origin : px.transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */
function calcSVGTransformOrigin(dimensions, originX, originY) {
  var pxOriginX = calcOrigin(originX, dimensions.x, dimensions.width);
  var pxOriginY = calcOrigin(originY, dimensions.y, dimensions.height);
  return "".concat(pxOriginX, " ").concat(pxOriginY);
}
var dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
};
var camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */
function buildSVGPath(attrs, length) {
  var spacing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var useDashCase = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  // Normalise path length by setting SVG attribute pathLength to 1
  attrs.pathLength = 1;
  // We use dash case when setting attributes directly to the DOM node and camel case
  // when defining props on a React component.
  var keys = useDashCase ? dashKeys : camelKeys;
  // Build the dash offset
  attrs[keys.offset] = px.transform(-offset);
  // Build the dash array
  var pathLength = px.transform(length);
  var pathSpacing = px.transform(spacing);
  attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}

/**
 * Build SVG visual attrbutes, like cx and style.transform
 */
function buildSVGAttrs(state, _ref3, options, isSVGTag, transformTemplate) {
  var attrX = _ref3.attrX,
    attrY = _ref3.attrY,
    attrScale = _ref3.attrScale,
    originX = _ref3.originX,
    originY = _ref3.originY,
    pathLength = _ref3.pathLength,
    _ref3$pathSpacing = _ref3.pathSpacing,
    pathSpacing = _ref3$pathSpacing === void 0 ? 1 : _ref3$pathSpacing,
    _ref3$pathOffset = _ref3.pathOffset,
    pathOffset = _ref3$pathOffset === void 0 ? 0 : _ref3$pathOffset,
    latest = _objectWithoutProperties(_ref3, _excluded);
  buildHTMLStyles(state, latest, options, transformTemplate);
  /**
   * For svg tags we just want to make sure viewBox is animatable and treat all the styles
   * as normal HTML tags.
   */
  if (isSVGTag) {
    if (state.style.viewBox) {
      state.attrs.viewBox = state.style.viewBox;
    }
    return;
  }
  state.attrs = state.style;
  state.style = {};
  var attrs = state.attrs,
    style = state.style,
    dimensions = state.dimensions;
  /**
   * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
   * and copy it into style.
   */
  if (attrs.transform) {
    if (dimensions) style.transform = attrs.transform;
    delete attrs.transform;
  }
  // Parse transformOrigin
  if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) {
    style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
  }
  // Render attrX/attrY/attrScale as attributes
  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY;
  if (attrScale !== undefined) attrs.scale = attrScale;
  // Build SVG path if one has been defined
  if (pathLength !== undefined) {
    buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
  }
}
var isSVGTag = function isSVGTag(tag) {
  return typeof tag === "string" && tag.toLowerCase() === "svg";
};

/**
 * Convert camelCase to dash-case properties.
 */
var camelToDash = function camelToDash(str) {
  return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};
function renderHTML(element, _ref4, styleProp, projection) {
  var style = _ref4.style,
    vars = _ref4.vars;
  Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
  // Loop over any CSS variables and assign those.
  for (var _key3 in vars) {
    element.style.setProperty(_key3, vars[_key3]);
  }
}

/**
 * A set of attribute names that are always read/written as camel case.
 */
var camelCaseAttributes = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);
function renderSVG(element, renderState, _styleProp, projection) {
  renderHTML(element, renderState, undefined, projection);
  for (var _key4 in renderState.attrs) {
    element.setAttribute(!camelCaseAttributes.has(_key4) ? camelToDash(_key4) : _key4, renderState.attrs[_key4]);
  }
}
function scrapeMotionValuesFromProps$1(props, prevProps) {
  var style = props.style;
  var newValues = {};
  for (var _key5 in style) {
    if (isMotionValue(style[_key5]) || prevProps.style && isMotionValue(prevProps.style[_key5]) || isForcedMotionValue(_key5, props)) {
      newValues[_key5] = style[_key5];
    }
  }
  return newValues;
}
function _scrapeMotionValuesFromProps(props, prevProps) {
  var newValues = scrapeMotionValuesFromProps$1(props, prevProps);
  for (var _key6 in props) {
    if (isMotionValue(props[_key6]) || isMotionValue(prevProps[_key6])) {
      var targetKey = transformPropOrder.indexOf(_key6) !== -1 ? "attr" + _key6.charAt(0).toUpperCase() + _key6.substring(1) : _key6;
      newValues[targetKey] = props[_key6];
    }
  }
  return newValues;
}
function resolveVariantFromProps(props, definition, custom) {
  var currentValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var currentVelocity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  /**
   * If the variant definition is a function, resolve.
   */
  if (typeof definition === "function") {
    definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
  }
  /**
   * If the variant definition is a variant label, or
   * the function returned a variant label, resolve.
   */
  if (typeof definition === "string") {
    definition = props.variants && props.variants[definition];
  }
  /**
   * At this point we've resolved both functions and variant labels,
   * but the resolved variant label might itself have been a function.
   * If so, resolve. This can only have returned a valid target object.
   */
  if (typeof definition === "function") {
    definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
  }
  return definition;
}
var isKeyframesTarget = function isKeyframesTarget(v) {
  return Array.isArray(v);
};
var isCustomValue = function isCustomValue(v) {
  return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function resolveFinalValueInKeyframes(v) {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};
var noop = function noop(any) {
  return any;
};
var Queue = /*#__PURE__*/function () {
  function Queue() {
    _classCallCheck(this, Queue);
    this.order = [];
    this.scheduled = new Set();
  }
  _createClass(Queue, [{
    key: "add",
    value: function add(process) {
      if (!this.scheduled.has(process)) {
        this.scheduled.add(process);
        this.order.push(process);
        return true;
      }
    }
  }, {
    key: "remove",
    value: function remove(process) {
      var index = this.order.indexOf(process);
      if (index !== -1) {
        this.order.splice(index, 1);
        this.scheduled.delete(process);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.order.length = 0;
      this.scheduled.clear();
    }
  }]);
  return Queue;
}();
function createRenderStep(runNextFrame) {
  /**
   * We create and reuse two queues, one to queue jobs for the current frame
   * and one for the next. We reuse to avoid triggering GC after x frames.
   */
  var thisFrame = new Queue();
  var nextFrame = new Queue();
  var numToRun = 0;
  /**
   * Track whether we're currently processing jobs in this step. This way
   * we can decide whether to schedule new jobs for this frame or next.
   */
  var isProcessing = false;
  var flushNextFrame = false;
  /**
   * A set of processes which were marked keepAlive when scheduled.
   */
  var toKeepAlive = new WeakSet();
  var step = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: function schedule(callback) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var addToCurrentFrame = immediate && isProcessing;
      var queue = addToCurrentFrame ? thisFrame : nextFrame;
      if (keepAlive) toKeepAlive.add(callback);
      if (queue.add(callback) && addToCurrentFrame && isProcessing) {
        // If we're adding it to the currently running queue, update its measured size
        numToRun = thisFrame.order.length;
      }
      return callback;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: function cancel(callback) {
      nextFrame.remove(callback);
      toKeepAlive.delete(callback);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: function process(frameData) {
      /**
       * If we're already processing we've probably been triggered by a flushSync
       * inside an existing process. Instead of executing, mark flushNextFrame
       * as true and ensure we flush the following frame at the end of this one.
       */
      if (isProcessing) {
        flushNextFrame = true;
        return;
      }
      isProcessing = true;
      // Clear the next frame queue
      var _ref5 = [nextFrame, thisFrame];
      thisFrame = _ref5[0];
      nextFrame = _ref5[1];
      nextFrame.clear();
      // Execute this frame
      numToRun = thisFrame.order.length;
      if (numToRun) {
        for (var i = 0; i < numToRun; i++) {
          var callback = thisFrame.order[i];
          callback(frameData);
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
          }
        }
      }
      isProcessing = false;
      if (flushNextFrame) {
        flushNextFrame = false;
        step.process(frameData);
      }
    }
  };
  return step;
}
var stepsOrder = ["prepare", "read", "update", "preRender", "render", "postRender"];
var maxElapsed$1 = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
  var runNextFrame = false;
  var useDefaultElapsed = true;
  var state = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
  };
  var steps = stepsOrder.reduce(function (acc, key) {
    acc[key] = createRenderStep(function () {
      return runNextFrame = true;
    });
    return acc;
  }, {});
  var processStep = function processStep(stepId) {
    return steps[stepId].process(state);
  };
  var processBatch = function processBatch() {
    var timestamp = performance.now();
    runNextFrame = false;
    state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed$1), 1);
    state.timestamp = timestamp;
    state.isProcessing = true;
    stepsOrder.forEach(processStep);
    state.isProcessing = false;
    if (runNextFrame && allowKeepAlive) {
      useDefaultElapsed = false;
      scheduleNextBatch(processBatch);
    }
  };
  var wake = function wake() {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!state.isProcessing) {
      scheduleNextBatch(processBatch);
    }
  };
  var schedule = stepsOrder.reduce(function (acc, key) {
    var step = steps[key];
    acc[key] = function (process) {
      var keepAlive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!runNextFrame) wake();
      return step.schedule(process, keepAlive, immediate);
    };
    return acc;
  }, {});
  var cancel = function cancel(process) {
    return stepsOrder.forEach(function (key) {
      return steps[key].cancel(process);
    });
  };
  return {
    schedule: schedule,
    cancel: cancel,
    state: state,
    steps: steps
  };
}
var _createRenderBatcher = createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true),
  frame = _createRenderBatcher.schedule,
  cancelFrame = _createRenderBatcher.cancel,
  frameData = _createRenderBatcher.state,
  steps = _createRenderBatcher.steps;

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
var combineFunctions = function combineFunctions(a, b) {
  return function (v) {
    return b(a(v));
  };
};
var pipe = function pipe() {
  for (var _len = arguments.length, transformers = new Array(_len), _key7 = 0; _key7 < _len; _key7++) {
    transformers[_key7] = arguments[_key7];
  }
  return transformers.reduce(combineFunctions);
};

/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */
function getCurrent(visualElement) {
  var current = {};
  visualElement.values.forEach(function (value, key) {
    return current[key] = value.get();
  });
  return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */
function getVelocity(visualElement) {
  var velocity = {};
  visualElement.values.forEach(function (value, key) {
    return velocity[key] = value.getVelocity();
  });
  return velocity;
}
function resolveVariant(visualElement, definition, custom) {
  var props = visualElement.getProps();
  return resolveVariantFromProps(props, definition, custom !== undefined ? custom : props.custom, getCurrent(visualElement), getVelocity(visualElement));
}
var optimizedAppearDataId = "framerAppearId";
var optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId);
exports.warning = noop;
exports.invariant = noop;
if (process.env.NODE_ENV !== "production") {
  exports.warning = function (check, message) {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  exports.invariant = function (check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function secondsToMilliseconds(seconds) {
  return seconds * 1000;
};
var millisecondsToSeconds = function millisecondsToSeconds(milliseconds) {
  return milliseconds / 1000;
};
var instantAnimationState = {
  current: false
};
var isBezierDefinition = function isBezierDefinition(easing) {
  return Array.isArray(easing) && typeof easing[0] === "number";
};
function isWaapiSupportedEasing(easing) {
  return Boolean(!easing || typeof easing === "string" && supportedWaapiEasing[easing] || isBezierDefinition(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}
var cubicBezierAsString = function cubicBezierAsString(_ref6) {
  var _ref7 = _slicedToArray(_ref6, 4),
    a = _ref7[0],
    b = _ref7[1],
    c = _ref7[2],
    d = _ref7[3];
  return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};
var supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(easing) {
  if (!easing) return undefined;
  return isBezierDefinition(easing) ? cubicBezierAsString(easing) : Array.isArray(easing) ? easing.map(mapEasingToNativeEasing) : supportedWaapiEasing[easing];
}
function animateStyle(element, valueName, keyframes) {
  var _ref8 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    _ref8$delay = _ref8.delay,
    delay = _ref8$delay === void 0 ? 0 : _ref8$delay,
    duration = _ref8.duration,
    _ref8$repeat = _ref8.repeat,
    repeat = _ref8$repeat === void 0 ? 0 : _ref8$repeat,
    _ref8$repeatType = _ref8.repeatType,
    repeatType = _ref8$repeatType === void 0 ? "loop" : _ref8$repeatType,
    ease = _ref8.ease,
    times = _ref8.times;
  var keyframeOptions = _defineProperty({}, valueName, keyframes);
  if (times) keyframeOptions.offset = times;
  var easing = mapEasingToNativeEasing(ease);
  /**
   * If this is an easing array, apply to keyframes, not animation as a whole
   */
  if (Array.isArray(easing)) keyframeOptions.easing = easing;
  return element.animate(keyframeOptions, {
    delay: delay,
    duration: duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  });
}
function getFinalKeyframe(keyframes, _ref9) {
  var repeat = _ref9.repeat,
    _ref9$repeatType = _ref9.repeatType,
    repeatType = _ref9$repeatType === void 0 ? "loop" : _ref9$repeatType;
  var index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
  return keyframes[index];
}

/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var calcBezier = function calcBezier(t, a1, a2) {
  return (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
};
var subdivisionPrecision = 0.0000001;
var subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
  var currentX;
  var currentT;
  var i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - x;
    if (currentX > 0.0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  // If this is a linear gradient, return linear easing
  if (mX1 === mY1 && mX2 === mY2) return noop;
  var getTForX = function getTForX(aX) {
    return binarySubdivide(aX, 0, 1, mX1, mX2);
  };
  // If animation is at start/end, return t without easing
  return function (t) {
    return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
  };
}
var easeIn = cubicBezier(0.42, 0, 1, 1);
var easeOut = cubicBezier(0, 0, 0.58, 1);
var easeInOut = cubicBezier(0.42, 0, 0.58, 1);
var isEasingArray = function isEasingArray(ease) {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};

// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var mirrorEasing = function mirrorEasing(easing) {
  return function (p) {
    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
  };
};

// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var reverseEasing = function reverseEasing(easing) {
  return function (p) {
    return 1 - easing(1 - p);
  };
};
var circIn = function circIn(p) {
  return 1 - Math.sin(Math.acos(p));
};
var circOut = reverseEasing(circIn);
var circInOut = mirrorEasing(circOut);
var backOut = cubicBezier(0.33, 1.53, 0.69, 0.99);
var backIn = reverseEasing(backOut);
var backInOut = mirrorEasing(backIn);
var anticipate = function anticipate(p) {
  return (p *= 2) < 1 ? 0.5 * backIn(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};
var easingLookup = {
  linear: noop,
  easeIn: easeIn,
  easeInOut: easeInOut,
  easeOut: easeOut,
  circIn: circIn,
  circInOut: circInOut,
  circOut: circOut,
  backIn: backIn,
  backInOut: backInOut,
  backOut: backOut,
  anticipate: anticipate
};
var easingDefinitionToFunction = function easingDefinitionToFunction(definition) {
  if (Array.isArray(definition)) {
    // If cubic bezier definition, create bezier curve
    exports.invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var _definition = _slicedToArray(definition, 4),
      x1 = _definition[0],
      y1 = _definition[1],
      x2 = _definition[2],
      y2 = _definition[3];
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    // Else lookup from table
    exports.invariant(easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
    return easingLookup[definition];
  }
  return definition;
};

/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */
var isColorString = function isColorString(type, testProp) {
  return function (v) {
    return Boolean(isString(v) && singleColorRegex.test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
  };
};
var splitColor = function splitColor(aName, bName, cName) {
  return function (v) {
    var _ref10;
    if (!isString(v)) return v;
    var _v$match = v.match(floatRegex),
      _v$match2 = _slicedToArray(_v$match, 4),
      a = _v$match2[0],
      b = _v$match2[1],
      c = _v$match2[2],
      alpha = _v$match2[3];
    return _ref10 = {}, _defineProperty(_ref10, aName, parseFloat(a)), _defineProperty(_ref10, bName, parseFloat(b)), _defineProperty(_ref10, cName, parseFloat(c)), _defineProperty(_ref10, "alpha", alpha !== undefined ? parseFloat(alpha) : 1), _ref10;
  };
};
var clampRgbUnit = function clampRgbUnit(v) {
  return clamp(0, 255, v);
};
var rgbUnit = _objectSpread(_objectSpread({}, number), {}, {
  transform: function transform(v) {
    return Math.round(clampRgbUnit(v));
  }
});
var rgba = {
  test: isColorString("rgb", "red"),
  parse: splitColor("red", "green", "blue"),
  transform: function transform(_ref11) {
    var red = _ref11.red,
      green = _ref11.green,
      blue = _ref11.blue,
      _ref11$alpha = _ref11.alpha,
      alpha$1 = _ref11$alpha === void 0 ? 1 : _ref11$alpha;
    return "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};
function parseHex(v) {
  var r = "";
  var g = "";
  var b = "";
  var a = "";
  // If we have 6 characters, ie #FF0000
  if (v.length > 5) {
    r = v.substring(1, 3);
    g = v.substring(3, 5);
    b = v.substring(5, 7);
    a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
  } else {
    r = v.substring(1, 2);
    g = v.substring(2, 3);
    b = v.substring(3, 4);
    a = v.substring(4, 5);
    r += r;
    g += g;
    b += b;
    a += a;
  }
  return {
    red: parseInt(r, 16),
    green: parseInt(g, 16),
    blue: parseInt(b, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
var hex = {
  test: isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
};
var hsla = {
  test: isColorString("hsl", "hue"),
  parse: splitColor("hue", "saturation", "lightness"),
  transform: function transform(_ref12) {
    var hue = _ref12.hue,
      saturation = _ref12.saturation,
      lightness = _ref12.lightness,
      _ref12$alpha = _ref12.alpha,
      alpha$1 = _ref12$alpha === void 0 ? 1 : _ref12$alpha;
    return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
  }
};
var color = {
  test: function test(v) {
    return rgba.test(v) || hex.test(v) || hsla.test(v);
  },
  parse: function parse(v) {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else {
      return hex.parse(v);
    }
  },
  transform: function transform(v) {
    return isString(v) ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
  }
};

/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/
var mix = function mix(from, to, progress) {
  return -progress * from + progress * to + from;
};

// Adapted from https://gist.github.com/mjackson/5311256
function hueToRgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslaToRgba(_ref13) {
  var hue = _ref13.hue,
    saturation = _ref13.saturation,
    lightness = _ref13.lightness,
    alpha = _ref13.alpha;
  hue /= 360;
  saturation /= 100;
  lightness /= 100;
  var red = 0;
  var green = 0;
  var blue = 0;
  if (!saturation) {
    red = green = blue = lightness;
  } else {
    var q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
    var p = 2 * lightness - q;
    red = hueToRgb(p, q, hue + 1 / 3);
    green = hueToRgb(p, q, hue);
    blue = hueToRgb(p, q, hue - 1 / 3);
  }
  return {
    red: Math.round(red * 255),
    green: Math.round(green * 255),
    blue: Math.round(blue * 255),
    alpha: alpha
  };
}

// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
var mixLinearColor = function mixLinearColor(from, to, v) {
  var fromExpo = from * from;
  return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
var colorTypes = [hex, rgba, hsla];
var getColorType = function getColorType(v) {
  return colorTypes.find(function (type) {
    return type.test(v);
  });
};
function asRGBA(color) {
  var type = getColorType(color);
  exports.invariant(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."));
  var model = type.parse(color);
  if (type === hsla) {
    // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = hslaToRgba(model);
  }
  return model;
}
var mixColor = function mixColor(from, to) {
  var fromRGBA = asRGBA(from);
  var toRGBA = asRGBA(to);
  var blended = _objectSpread({}, fromRGBA);
  return function (v) {
    blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
    blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
    blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
    blended.alpha = mix(fromRGBA.alpha, toRGBA.alpha, v);
    return rgba.transform(blended);
  };
};
function test(v) {
  var _a, _b;
  return isNaN(v) && isString(v) && (((_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex)) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
var cssVarTokeniser = {
  regex: cssVariableRegex,
  countKey: "Vars",
  token: "${v}",
  parse: noop
};
var colorTokeniser = {
  regex: colorRegex,
  countKey: "Colors",
  token: "${c}",
  parse: color.parse
};
var numberTokeniser = {
  regex: floatRegex,
  countKey: "Numbers",
  token: "${n}",
  parse: number.parse
};
function tokenise(info, _ref14) {
  var _info$values;
  var regex = _ref14.regex,
    countKey = _ref14.countKey,
    token = _ref14.token,
    parse = _ref14.parse;
  var matches = info.tokenised.match(regex);
  if (!matches) return;
  info["num" + countKey] = matches.length;
  info.tokenised = info.tokenised.replace(regex, token);
  (_info$values = info.values).push.apply(_info$values, _toConsumableArray(matches.map(parse)));
}
function analyseComplexValue(value) {
  var originalValue = value.toString();
  var info = {
    value: originalValue,
    tokenised: originalValue,
    values: [],
    numVars: 0,
    numColors: 0,
    numNumbers: 0
  };
  if (info.value.includes("var(--")) tokenise(info, cssVarTokeniser);
  tokenise(info, colorTokeniser);
  tokenise(info, numberTokeniser);
  return info;
}
function parseComplexValue(v) {
  return analyseComplexValue(v).values;
}
function createTransformer(source) {
  var _analyseComplexValue = analyseComplexValue(source),
    values = _analyseComplexValue.values,
    numColors = _analyseComplexValue.numColors,
    numVars = _analyseComplexValue.numVars,
    tokenised = _analyseComplexValue.tokenised;
  var numValues = values.length;
  return function (v) {
    var output = tokenised;
    for (var i = 0; i < numValues; i++) {
      if (i < numVars) {
        output = output.replace(cssVarTokeniser.token, v[i]);
      } else if (i < numVars + numColors) {
        output = output.replace(colorTokeniser.token, color.transform(v[i]));
      } else {
        output = output.replace(numberTokeniser.token, sanitize(v[i]));
      }
    }
    return output;
  };
}
var convertNumbersToZero = function convertNumbersToZero(v) {
  return typeof v === "number" ? 0 : v;
};
function getAnimatableNone$1(v) {
  var parsed = parseComplexValue(v);
  var transformer = createTransformer(v);
  return transformer(parsed.map(convertNumbersToZero));
}
var complex = {
  test: test,
  parse: parseComplexValue,
  createTransformer: createTransformer,
  getAnimatableNone: getAnimatableNone$1
};
var mixImmediate = function mixImmediate(origin, target) {
  return function (p) {
    return "".concat(p > 0 ? target : origin);
  };
};
function getMixer$1(origin, target) {
  if (typeof origin === "number") {
    return function (v) {
      return mix(origin, target, v);
    };
  } else if (color.test(origin)) {
    return mixColor(origin, target);
  } else {
    return origin.startsWith("var(") ? mixImmediate(origin, target) : mixComplex(origin, target);
  }
}
var mixArray = function mixArray(from, to) {
  var output = _toConsumableArray(from);
  var numValues = output.length;
  var blendValue = from.map(function (fromThis, i) {
    return getMixer$1(fromThis, to[i]);
  });
  return function (v) {
    for (var i = 0; i < numValues; i++) {
      output[i] = blendValue[i](v);
    }
    return output;
  };
};
var mixObject = function mixObject(origin, target) {
  var output = _objectSpread(_objectSpread({}, origin), target);
  var blendValue = {};
  for (var _key8 in output) {
    if (origin[_key8] !== undefined && target[_key8] !== undefined) {
      blendValue[_key8] = getMixer$1(origin[_key8], target[_key8]);
    }
  }
  return function (v) {
    for (var _key9 in blendValue) {
      output[_key9] = blendValue[_key9](v);
    }
    return output;
  };
};
var mixComplex = function mixComplex(origin, target) {
  var template = complex.createTransformer(target);
  var originStats = analyseComplexValue(origin);
  var targetStats = analyseComplexValue(target);
  var canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
  if (canInterpolate) {
    return pipe(mixArray(originStats.values, targetStats.values), template);
  } else {
    exports.warning(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."));
    return mixImmediate(origin, target);
  }
};

/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/
var progress = function progress(from, to, value) {
  var toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};
var mixNumber = function mixNumber(from, to) {
  return function (p) {
    return mix(from, to, p);
  };
};
function detectMixerFactory(v) {
  if (typeof v === "number") {
    return mixNumber;
  } else if (typeof v === "string") {
    return color.test(v) ? mixColor : mixComplex;
  } else if (Array.isArray(v)) {
    return mixArray;
  } else if (typeof v === "object") {
    return mixObject;
  }
  return mixNumber;
}
function createMixers(output, ease, customMixer) {
  var mixers = [];
  var mixerFactory = customMixer || detectMixerFactory(output[0]);
  var numMixers = output.length - 1;
  for (var i = 0; i < numMixers; i++) {
    var mixer = mixerFactory(output[i], output[i + 1]);
    if (ease) {
      var easingFunction = Array.isArray(ease) ? ease[i] || noop : ease;
      mixer = pipe(easingFunction, mixer);
    }
    mixers.push(mixer);
  }
  return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */
function interpolate(input, output) {
  var _ref15 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref15$clamp = _ref15.clamp,
    isClamp = _ref15$clamp === void 0 ? true : _ref15$clamp,
    ease = _ref15.ease,
    mixer = _ref15.mixer;
  var inputLength = input.length;
  exports.invariant(inputLength === output.length, "Both input and output ranges must be the same length");
  /**
   * If we're only provided a single input, we can just make a function
   * that returns the output.
   */
  if (inputLength === 1) return function () {
    return output[0];
  };
  // If input runs highest -> lowest, reverse both arrays
  if (input[0] > input[inputLength - 1]) {
    input = _toConsumableArray(input).reverse();
    output = _toConsumableArray(output).reverse();
  }
  var mixers = createMixers(output, ease, mixer);
  var numMixers = mixers.length;
  var interpolator = function interpolator(v) {
    var i = 0;
    if (numMixers > 1) {
      for (; i < input.length - 2; i++) {
        if (v < input[i + 1]) break;
      }
    }
    var progressInRange = progress(input[i], input[i + 1], v);
    return mixers[i](progressInRange);
  };
  return isClamp ? function (v) {
    return interpolator(clamp(input[0], input[inputLength - 1], v));
  } : interpolator;
}
function fillOffset(offset, remaining) {
  var min = offset[offset.length - 1];
  for (var i = 1; i <= remaining; i++) {
    var offsetProgress = progress(0, remaining, i);
    offset.push(mix(min, 1, offsetProgress));
  }
}
function defaultOffset$1(arr) {
  var offset = [0];
  fillOffset(offset, arr.length - 1);
  return offset;
}
function convertOffsetToTimes(offset, duration) {
  return offset.map(function (o) {
    return o * duration;
  });
}
function defaultEasing(values, easing) {
  return values.map(function () {
    return easing || easeInOut;
  }).splice(0, values.length - 1);
}
function keyframes(_ref16) {
  var _ref16$duration = _ref16.duration,
    duration = _ref16$duration === void 0 ? 300 : _ref16$duration,
    keyframeValues = _ref16.keyframes,
    times = _ref16.times,
    _ref16$ease = _ref16.ease,
    ease = _ref16$ease === void 0 ? "easeInOut" : _ref16$ease;
  /**
   * Easing functions can be externally defined as strings. Here we convert them
   * into actual functions.
   */
  var easingFunctions = isEasingArray(ease) ? ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(ease);
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  var state = {
    done: false,
    value: keyframeValues[0]
  };
  /**
   * Create a times array based on the provided 0-1 offsets
   */
  var absoluteTimes = convertOffsetToTimes(
  // Only use the provided offsets if they're the correct length
  // TODO Maybe we should warn here if there's a length mismatch
  times && times.length === keyframeValues.length ? times : defaultOffset$1(keyframeValues), duration);
  var mapTimeToKeyframe = interpolate(absoluteTimes, keyframeValues, {
    ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
  });
  return {
    calculatedDuration: duration,
    next: function next(t) {
      state.value = mapTimeToKeyframe(t);
      state.done = t >= duration;
      return state;
    }
  };
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/
function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1000 / frameDuration) : 0;
}
var velocitySampleDuration = 5; // ms
function calcGeneratorVelocity(resolveValue, t, current) {
  var prevT = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(current - resolveValue(prevT), t - prevT);
}
var safeMin = 0.001;
var minDuration = 0.01;
var maxDuration$1 = 10.0;
var minDamping = 0.05;
var maxDamping = 1;
function findSpring(_ref17) {
  var _ref17$duration = _ref17.duration,
    duration = _ref17$duration === void 0 ? 800 : _ref17$duration,
    _ref17$bounce = _ref17.bounce,
    bounce = _ref17$bounce === void 0 ? 0.25 : _ref17$bounce,
    _ref17$velocity = _ref17.velocity,
    velocity = _ref17$velocity === void 0 ? 0 : _ref17$velocity,
    _ref17$mass = _ref17.mass,
    mass = _ref17$mass === void 0 ? 1 : _ref17$mass;
  var envelope;
  var derivative;
  exports.warning(duration <= secondsToMilliseconds(maxDuration$1), "Spring duration must be 10 seconds or less");
  var dampingRatio = 1 - bounce;
  /**
   * Restrict dampingRatio and duration to within acceptable ranges.
   */
  dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
  duration = clamp(minDuration, maxDuration$1, millisecondsToSeconds(duration));
  if (dampingRatio < 1) {
    /**
     * Underdamped spring
     */
    envelope = function envelope(undampedFreq) {
      var exponentialDecay = undampedFreq * dampingRatio;
      var delta = exponentialDecay * duration;
      var a = exponentialDecay - velocity;
      var b = calcAngularFreq(undampedFreq, dampingRatio);
      var c = Math.exp(-delta);
      return safeMin - a / b * c;
    };
    derivative = function derivative(undampedFreq) {
      var exponentialDecay = undampedFreq * dampingRatio;
      var delta = exponentialDecay * duration;
      var d = delta * velocity + velocity;
      var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
      var f = Math.exp(-delta);
      var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
      var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
      return factor * ((d - e) * f) / g;
    };
  } else {
    /**
     * Critically-damped spring
     */
    envelope = function envelope(undampedFreq) {
      var a = Math.exp(-undampedFreq * duration);
      var b = (undampedFreq - velocity) * duration + 1;
      return -safeMin + a * b;
    };
    derivative = function derivative(undampedFreq) {
      var a = Math.exp(-undampedFreq * duration);
      var b = (velocity - undampedFreq) * (duration * duration);
      return a * b;
    };
  }
  var initialGuess = 5 / duration;
  var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
  duration = secondsToMilliseconds(duration);
  if (isNaN(undampedFreq)) {
    return {
      stiffness: 100,
      damping: 10,
      duration: duration
    };
  } else {
    var stiffness = Math.pow(undampedFreq, 2) * mass;
    return {
      stiffness: stiffness,
      damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
      duration: duration
    };
  }
}
var rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
  var result = initialGuess;
  for (var i = 1; i < rootIterations; i++) {
    result = result - envelope(result) / derivative(result);
  }
  return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
  return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
var durationKeys = ["duration", "bounce"];
var physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
  return keys.some(function (key) {
    return options[key] !== undefined;
  });
}
function getSpringOptions(options) {
  var springOptions = _objectSpread({
    velocity: 0.0,
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    isResolvedFromDuration: false
  }, options);
  // stiffness/damping/mass overrides duration/bounce
  if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
    var derived = findSpring(options);
    springOptions = _objectSpread(_objectSpread(_objectSpread({}, springOptions), derived), {}, {
      velocity: 0.0,
      mass: 1.0
    });
    springOptions.isResolvedFromDuration = true;
  }
  return springOptions;
}
function spring(_ref18) {
  var keyframes = _ref18.keyframes,
    restDelta = _ref18.restDelta,
    restSpeed = _ref18.restSpeed,
    options = _objectWithoutProperties(_ref18, _excluded2);
  var origin = keyframes[0];
  var target = keyframes[keyframes.length - 1];
  /**
   * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
   * to reduce GC during animation.
   */
  var state = {
    done: false,
    value: origin
  };
  var _getSpringOptions = getSpringOptions(options),
    stiffness = _getSpringOptions.stiffness,
    damping = _getSpringOptions.damping,
    mass = _getSpringOptions.mass,
    velocity = _getSpringOptions.velocity,
    duration = _getSpringOptions.duration,
    isResolvedFromDuration = _getSpringOptions.isResolvedFromDuration;
  var initialVelocity = velocity ? -millisecondsToSeconds(velocity) : 0.0;
  var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
  var initialDelta = target - origin;
  var undampedAngularFreq = millisecondsToSeconds(Math.sqrt(stiffness / mass));
  /**
   * If we're working on a granular scale, use smaller defaults for determining
   * when the spring is finished.
   *
   * These defaults have been selected emprically based on what strikes a good
   * ratio between feeling good and finishing as soon as changes are imperceptible.
   */
  var isGranularScale = Math.abs(initialDelta) < 5;
  restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
  restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
  var resolveSpring;
  if (dampingRatio < 1) {
    var angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
    // Underdamped spring
    resolveSpring = function resolveSpring(t) {
      var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
    };
  } else if (dampingRatio === 1) {
    // Critically damped spring
    resolveSpring = function resolveSpring(t) {
      return target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    };
  } else {
    // Overdamped spring
    var dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
    resolveSpring = function resolveSpring(t) {
      var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
      // When performing sinh or cosh values can hit Infinity so we cap them here
      var freqForT = Math.min(dampedAngularFreq * t, 300);
      return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
    };
  }
  return {
    calculatedDuration: isResolvedFromDuration ? duration || null : null,
    next: function next(t) {
      var current = resolveSpring(t);
      if (!isResolvedFromDuration) {
        var currentVelocity = initialVelocity;
        if (t !== 0) {
          /**
           * We only need to calculate velocity for under-damped springs
           * as over- and critically-damped springs can't overshoot, so
           * checking only for displacement is enough.
           */
          if (dampingRatio < 1) {
            currentVelocity = calcGeneratorVelocity(resolveSpring, t, current);
          } else {
            currentVelocity = 0;
          }
        }
        var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
        var isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
        state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
      } else {
        state.done = t >= duration;
      }
      state.value = state.done ? target : current;
      return state;
    }
  };
}
function inertia(_ref19) {
  var keyframes = _ref19.keyframes,
    _ref19$velocity = _ref19.velocity,
    velocity = _ref19$velocity === void 0 ? 0.0 : _ref19$velocity,
    _ref19$power = _ref19.power,
    power = _ref19$power === void 0 ? 0.8 : _ref19$power,
    _ref19$timeConstant = _ref19.timeConstant,
    timeConstant = _ref19$timeConstant === void 0 ? 325 : _ref19$timeConstant,
    _ref19$bounceDamping = _ref19.bounceDamping,
    bounceDamping = _ref19$bounceDamping === void 0 ? 10 : _ref19$bounceDamping,
    _ref19$bounceStiffnes = _ref19.bounceStiffness,
    bounceStiffness = _ref19$bounceStiffnes === void 0 ? 500 : _ref19$bounceStiffnes,
    modifyTarget = _ref19.modifyTarget,
    min = _ref19.min,
    max = _ref19.max,
    _ref19$restDelta = _ref19.restDelta,
    restDelta = _ref19$restDelta === void 0 ? 0.5 : _ref19$restDelta,
    restSpeed = _ref19.restSpeed;
  var origin = keyframes[0];
  var state = {
    done: false,
    value: origin
  };
  var isOutOfBounds = function isOutOfBounds(v) {
    return min !== undefined && v < min || max !== undefined && v > max;
  };
  var nearestBoundary = function nearestBoundary(v) {
    if (min === undefined) return max;
    if (max === undefined) return min;
    return Math.abs(min - v) < Math.abs(max - v) ? min : max;
  };
  var amplitude = power * velocity;
  var ideal = origin + amplitude;
  var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
  /**
   * If the target has changed we need to re-calculate the amplitude, otherwise
   * the animation will start from the wrong position.
   */
  if (target !== ideal) amplitude = target - origin;
  var calcDelta = function calcDelta(t) {
    return -amplitude * Math.exp(-t / timeConstant);
  };
  var calcLatest = function calcLatest(t) {
    return target + calcDelta(t);
  };
  var applyFriction = function applyFriction(t) {
    var delta = calcDelta(t);
    var latest = calcLatest(t);
    state.done = Math.abs(delta) <= restDelta;
    state.value = state.done ? target : latest;
  };
  /**
   * Ideally this would resolve for t in a stateless way, we could
   * do that by always precalculating the animation but as we know
   * this will be done anyway we can assume that spring will
   * be discovered during that.
   */
  var timeReachedBoundary;
  var spring$1;
  var checkCatchBoundary = function checkCatchBoundary(t) {
    if (!isOutOfBounds(state.value)) return;
    timeReachedBoundary = t;
    spring$1 = spring({
      keyframes: [state.value, nearestBoundary(state.value)],
      velocity: calcGeneratorVelocity(calcLatest, t, state.value),
      damping: bounceDamping,
      stiffness: bounceStiffness,
      restDelta: restDelta,
      restSpeed: restSpeed
    });
  };
  checkCatchBoundary(0);
  return {
    calculatedDuration: null,
    next: function next(t) {
      /**
       * We need to resolve the friction to figure out if we need a
       * spring but we don't want to do this twice per frame. So here
       * we flag if we updated for this frame and later if we did
       * we can skip doing it again.
       */
      var hasUpdatedFrame = false;
      if (!spring$1 && timeReachedBoundary === undefined) {
        hasUpdatedFrame = true;
        applyFriction(t);
        checkCatchBoundary(t);
      }
      /**
       * If we have a spring and the provided t is beyond the moment the friction
       * animation crossed the min/max boundary, use the spring.
       */
      if (timeReachedBoundary !== undefined && t > timeReachedBoundary) {
        return spring$1.next(t - timeReachedBoundary);
      } else {
        !hasUpdatedFrame && applyFriction(t);
        return state;
      }
    }
  };
}
var frameloopDriver = function frameloopDriver(update) {
  var passTimestamp = function passTimestamp(_ref20) {
    var timestamp = _ref20.timestamp;
    return update(timestamp);
  };
  return {
    start: function start() {
      return frame.update(passTimestamp, true);
    },
    stop: function stop() {
      return cancelFrame(passTimestamp);
    },
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: function now() {
      return frameData.isProcessing ? frameData.timestamp : performance.now();
    }
  };
};

/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
var maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
  var duration = 0;
  var timeStep = 50;
  var state = generator.next(duration);
  while (!state.done && duration < maxGeneratorDuration) {
    duration += timeStep;
    state = generator.next(duration);
  }
  return duration >= maxGeneratorDuration ? Infinity : duration;
}
var types = {
  decay: inertia,
  inertia: inertia,
  tween: keyframes,
  keyframes: keyframes,
  spring: spring
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */
function animateValue(_ref21) {
  var _ref21$autoplay = _ref21.autoplay,
    autoplay = _ref21$autoplay === void 0 ? true : _ref21$autoplay,
    _ref21$delay = _ref21.delay,
    delay = _ref21$delay === void 0 ? 0 : _ref21$delay,
    _ref21$driver = _ref21.driver,
    driver = _ref21$driver === void 0 ? frameloopDriver : _ref21$driver,
    keyframes$1 = _ref21.keyframes,
    _ref21$type = _ref21.type,
    type = _ref21$type === void 0 ? "keyframes" : _ref21$type,
    _ref21$repeat = _ref21.repeat,
    repeat = _ref21$repeat === void 0 ? 0 : _ref21$repeat,
    _ref21$repeatDelay = _ref21.repeatDelay,
    repeatDelay = _ref21$repeatDelay === void 0 ? 0 : _ref21$repeatDelay,
    _ref21$repeatType = _ref21.repeatType,
    repeatType = _ref21$repeatType === void 0 ? "loop" : _ref21$repeatType,
    onPlay = _ref21.onPlay,
    onStop = _ref21.onStop,
    onComplete = _ref21.onComplete,
    onUpdate = _ref21.onUpdate,
    options = _objectWithoutProperties(_ref21, _excluded3);
  var speed = 1;
  var hasStopped = false;
  var resolveFinishedPromise;
  var currentFinishedPromise;
  /**
   * Resolve the current Promise every time we enter the
   * finished state. This is WAAPI-compatible behaviour.
   */
  var updateFinishedPromise = function updateFinishedPromise() {
    currentFinishedPromise = new Promise(function (resolve) {
      resolveFinishedPromise = resolve;
    });
  };
  // Create the first finished promise
  updateFinishedPromise();
  var animationDriver;
  var generatorFactory = types[type] || keyframes;
  /**
   * If this isn't the keyframes generator and we've been provided
   * strings as keyframes, we need to interpolate these.
   * TODO: Support velocity for units and complex value types/
   */
  var mapNumbersToKeyframes;
  if (generatorFactory !== keyframes && typeof keyframes$1[0] !== "number") {
    mapNumbersToKeyframes = interpolate([0, 100], keyframes$1, {
      clamp: false
    });
    keyframes$1 = [0, 100];
  }
  var generator = generatorFactory(_objectSpread(_objectSpread({}, options), {}, {
    keyframes: keyframes$1
  }));
  var mirroredGenerator;
  if (repeatType === "mirror") {
    mirroredGenerator = generatorFactory(_objectSpread(_objectSpread({}, options), {}, {
      keyframes: _toConsumableArray(keyframes$1).reverse(),
      velocity: -(options.velocity || 0)
    }));
  }
  var playState = "idle";
  var holdTime = null;
  var startTime = null;
  var cancelTime = null;
  /**
   * If duration is undefined and we have repeat options,
   * we need to calculate a duration from the generator.
   *
   * We set it to the generator itself to cache the duration.
   * Any timeline resolver will need to have already precalculated
   * the duration by this step.
   */
  if (generator.calculatedDuration === null && repeat) {
    generator.calculatedDuration = calcGeneratorDuration(generator);
  }
  var calculatedDuration = generator.calculatedDuration;
  var resolvedDuration = Infinity;
  var totalDuration = Infinity;
  if (calculatedDuration !== null) {
    resolvedDuration = calculatedDuration + repeatDelay;
    totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
  }
  var currentTime = 0;
  var tick = function tick(timestamp) {
    if (startTime === null) return;
    /**
     * requestAnimationFrame timestamps can come through as lower than
     * the startTime as set by performance.now(). Here we prevent this,
     * though in the future it could be possible to make setting startTime
     * a pending operation that gets resolved here.
     */
    if (speed > 0) startTime = Math.min(startTime, timestamp);
    if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
    if (holdTime !== null) {
      currentTime = holdTime;
    } else {
      // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
      // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
      // example.
      currentTime = Math.round(timestamp - startTime) * speed;
    }
    // Rebase on delay
    var timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
    var isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
    currentTime = Math.max(timeWithoutDelay, 0);
    /**
     * If this animation has finished, set the current time
     * to the total duration.
     */
    if (playState === "finished" && holdTime === null) {
      currentTime = totalDuration;
    }
    var elapsed = currentTime;
    var frameGenerator = generator;
    if (repeat) {
      /**
       * Get the current progress (0-1) of the animation. If t is >
       * than duration we'll get values like 2.5 (midway through the
       * third iteration)
       */
      var _progress = currentTime / resolvedDuration;
      /**
       * Get the current iteration (0 indexed). For instance the floor of
       * 2.5 is 2.
       */
      var currentIteration = Math.floor(_progress);
      /**
       * Get the current progress of the iteration by taking the remainder
       * so 2.5 is 0.5 through iteration 2
       */
      var iterationProgress = _progress % 1.0;
      /**
       * If iteration progress is 1 we count that as the end
       * of the previous iteration.
       */
      if (!iterationProgress && _progress >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      currentIteration = Math.min(currentIteration, repeat + 1);
      /**
       * Reverse progress if we're not running in "normal" direction
       */
      var iterationIsOdd = Boolean(currentIteration % 2);
      if (iterationIsOdd) {
        if (repeatType === "reverse") {
          iterationProgress = 1 - iterationProgress;
          if (repeatDelay) {
            iterationProgress -= repeatDelay / resolvedDuration;
          }
        } else if (repeatType === "mirror") {
          frameGenerator = mirroredGenerator;
        }
      }
      var p = clamp(0, 1, iterationProgress);
      if (currentTime > totalDuration) {
        p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
      }
      elapsed = p * resolvedDuration;
    }
    /**
     * If we're in negative time, set state as the initial keyframe.
     * This prevents delay: x, duration: 0 animations from finishing
     * instantly.
     */
    var state = isInDelayPhase ? {
      done: false,
      value: keyframes$1[0]
    } : frameGenerator.next(elapsed);
    if (mapNumbersToKeyframes) {
      state.value = mapNumbersToKeyframes(state.value);
    }
    var done = state.done;
    if (!isInDelayPhase && calculatedDuration !== null) {
      done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
    }
    var isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
    if (onUpdate) {
      onUpdate(state.value);
    }
    if (isAnimationFinished) {
      finish();
    }
    return state;
  };
  var stopAnimationDriver = function stopAnimationDriver() {
    animationDriver && animationDriver.stop();
    animationDriver = undefined;
  };
  var _cancel = function cancel() {
    playState = "idle";
    stopAnimationDriver();
    resolveFinishedPromise();
    updateFinishedPromise();
    startTime = cancelTime = null;
  };
  var finish = function finish() {
    playState = "finished";
    onComplete && onComplete();
    stopAnimationDriver();
    resolveFinishedPromise();
  };
  var play = function play() {
    if (hasStopped) return;
    if (!animationDriver) animationDriver = driver(tick);
    var now = animationDriver.now();
    onPlay && onPlay();
    if (holdTime !== null) {
      startTime = now - holdTime;
    } else if (!startTime || playState === "finished") {
      startTime = now;
    }
    if (playState === "finished") {
      updateFinishedPromise();
    }
    cancelTime = startTime;
    holdTime = null;
    /**
     * Set playState to running only after we've used it in
     * the previous logic.
     */
    playState = "running";
    animationDriver.start();
  };
  if (autoplay) {
    play();
  }
  var controls = {
    then: function then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    get time() {
      return millisecondsToSeconds(currentTime);
    },
    set time(newTime) {
      newTime = secondsToMilliseconds(newTime);
      currentTime = newTime;
      if (holdTime !== null || !animationDriver || speed === 0) {
        holdTime = newTime;
      } else {
        startTime = animationDriver.now() - newTime / speed;
      }
    },
    get duration() {
      var duration = generator.calculatedDuration === null ? calcGeneratorDuration(generator) : generator.calculatedDuration;
      return millisecondsToSeconds(duration);
    },
    get speed() {
      return speed;
    },
    set speed(newSpeed) {
      if (newSpeed === speed || !animationDriver) return;
      speed = newSpeed;
      controls.time = millisecondsToSeconds(currentTime);
    },
    get state() {
      return playState;
    },
    play: play,
    pause: function pause() {
      playState = "paused";
      holdTime = currentTime;
    },
    stop: function stop() {
      hasStopped = true;
      if (playState === "idle") return;
      playState = "idle";
      onStop && onStop();
      _cancel();
    },
    cancel: function cancel() {
      if (cancelTime !== null) tick(cancelTime);
      _cancel();
    },
    complete: function complete() {
      playState = "finished";
    },
    sample: function sample(elapsed) {
      startTime = 0;
      return tick(elapsed);
    }
  };
  return controls;
}
function memo(callback) {
  var result;
  return function () {
    if (result === undefined) result = callback();
    return result;
  };
}
var supportsWaapi = memo(function () {
  return Object.hasOwnProperty.call(Element.prototype, "animate");
});
/**
 * A list of values that can be hardware-accelerated.
 */
var acceleratedValues = new Set(["opacity", "clipPath", "filter", "transform", "backgroundColor"]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */
var sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */
var maxDuration = 20000;
var requiresPregeneratedKeyframes = function requiresPregeneratedKeyframes(valueName, options) {
  return options.type === "spring" || valueName === "backgroundColor" || !isWaapiSupportedEasing(options.ease);
};
function createAcceleratedAnimation(value, valueName, _ref22) {
  var onUpdate = _ref22.onUpdate,
    onComplete = _ref22.onComplete,
    options = _objectWithoutProperties(_ref22, _excluded4);
  var canAccelerateAnimation = supportsWaapi() && acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
  if (!canAccelerateAnimation) return false;
  /**
   * TODO: Unify with js/index
   */
  var hasStopped = false;
  var resolveFinishedPromise;
  var currentFinishedPromise;
  /**
   * Resolve the current Promise every time we enter the
   * finished state. This is WAAPI-compatible behaviour.
   */
  var updateFinishedPromise = function updateFinishedPromise() {
    currentFinishedPromise = new Promise(function (resolve) {
      resolveFinishedPromise = resolve;
    });
  };
  // Create the first finished promise
  updateFinishedPromise();
  var keyframes = options.keyframes,
    _options$duration = options.duration,
    duration = _options$duration === void 0 ? 300 : _options$duration,
    ease = options.ease,
    times = options.times;
  /**
   * If this animation needs pre-generated keyframes then generate.
   */
  if (requiresPregeneratedKeyframes(valueName, options)) {
    var sampleAnimation = animateValue(_objectSpread(_objectSpread({}, options), {}, {
      repeat: 0,
      delay: 0
    }));
    var state = {
      done: false,
      value: keyframes[0]
    };
    var pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */
    var t = 0;
    while (!state.done && t < maxDuration) {
      state = sampleAnimation.sample(t);
      pregeneratedKeyframes.push(state.value);
      t += sampleDelta;
    }
    times = undefined;
    keyframes = pregeneratedKeyframes;
    duration = t - sampleDelta;
    ease = "linear";
  }
  var animation = animateStyle(value.owner.current, valueName, keyframes, _objectSpread(_objectSpread({}, options), {}, {
    duration: duration,
    /**
     * This function is currently not called if ease is provided
     * as a function so the cast is safe.
     *
     * However it would be possible for a future refinement to port
     * in easing pregeneration from Motion One for browsers that
     * support the upcoming `linear()` easing function.
     */
    ease: ease,
    times: times
  }));
  /**
   * WAAPI animations don't resolve startTime synchronously. But a blocked
   * thread could delay the startTime resolution by a noticeable amount.
   * For synching handoff animations with the new Motion animation we want
   * to ensure startTime is synchronously set.
   */
  if (options.syncStart) {
    animation.startTime = frameData.isProcessing ? frameData.timestamp : document.timeline ? document.timeline.currentTime : performance.now();
  }
  var cancelAnimation = function cancelAnimation() {
    return animation.cancel();
  };
  var safeCancel = function safeCancel() {
    frame.update(cancelAnimation);
    resolveFinishedPromise();
    updateFinishedPromise();
  };
  /**
   * Prefer the `onfinish` prop as it's more widely supported than
   * the `finished` promise.
   *
   * Here, we synchronously set the provided MotionValue to the end
   * keyframe. If we didn't, when the WAAPI animation is finished it would
   * be removed from the element which would then revert to its old styles.
   */
  animation.onfinish = function () {
    value.set(getFinalKeyframe(keyframes, options));
    onComplete && onComplete();
    safeCancel();
  };
  /**
   * Animation interrupt callback.
   */
  var controls = {
    then: function then(resolve, reject) {
      return currentFinishedPromise.then(resolve, reject);
    },
    attachTimeline: function attachTimeline(timeline) {
      animation.timeline = timeline;
      animation.onfinish = null;
      return noop;
    },
    get time() {
      return millisecondsToSeconds(animation.currentTime || 0);
    },
    set time(newTime) {
      animation.currentTime = secondsToMilliseconds(newTime);
    },
    get speed() {
      return animation.playbackRate;
    },
    set speed(newSpeed) {
      animation.playbackRate = newSpeed;
    },
    get duration() {
      return millisecondsToSeconds(duration);
    },
    play: function play() {
      if (hasStopped) return;
      animation.play();
      /**
       * Cancel any pending cancel tasks
       */
      cancelFrame(cancelAnimation);
    },
    pause: function pause() {
      return animation.pause();
    },
    stop: function stop() {
      hasStopped = true;
      if (animation.playState === "idle") return;
      /**
       * WAAPI doesn't natively have any interruption capabilities.
       *
       * Rather than read commited styles back out of the DOM, we can
       * create a renderless JS animation and sample it twice to calculate
       * its current value, "previous" value, and therefore allow
       * Motion to calculate velocity for any subsequent animation.
       */
      var currentTime = animation.currentTime;
      if (currentTime) {
        var _sampleAnimation = animateValue(_objectSpread(_objectSpread({}, options), {}, {
          autoplay: false
        }));
        value.setWithVelocity(_sampleAnimation.sample(currentTime - sampleDelta).value, _sampleAnimation.sample(currentTime).value, sampleDelta);
      }
      safeCancel();
    },
    complete: function complete() {
      return animation.finish();
    },
    cancel: safeCancel
  };
  return controls;
}
function createInstantAnimation(_ref23) {
  var keyframes = _ref23.keyframes,
    delay = _ref23.delay,
    onUpdate = _ref23.onUpdate,
    onComplete = _ref23.onComplete;
  var setValue = function setValue() {
    onUpdate && onUpdate(keyframes[keyframes.length - 1]);
    onComplete && onComplete();
    /**
     * TODO: As this API grows it could make sense to always return
     * animateValue. This will be a bigger project as animateValue
     * is frame-locked whereas this function resolves instantly.
     * This is a behavioural change and also has ramifications regarding
     * assumptions within tests.
     */
    return {
      time: 0,
      speed: 1,
      duration: 0,
      play: noop,
      pause: noop,
      stop: noop,
      then: function then(resolve) {
        resolve();
        return Promise.resolve();
      },
      cancel: noop,
      complete: noop
    };
  };
  return delay ? animateValue({
    keyframes: [0, 1],
    duration: 0,
    delay: delay,
    onComplete: setValue
  }) : setValue();
}
var underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
};
var criticallyDampedSpring = function criticallyDampedSpring(target) {
  return {
    type: "spring",
    stiffness: 550,
    damping: target === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
};
var keyframesTransition = {
  type: "keyframes",
  duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */
var ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
};
var getDefaultTransition = function getDefaultTransition(valueKey, _ref24) {
  var keyframes = _ref24.keyframes;
  if (keyframes.length > 2) {
    return keyframesTransition;
  } else if (transformProps.has(valueKey)) {
    return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
  }
  return ease;
};

/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */
var isAnimatable = function isAnimatable(key, value) {
  // If the list of keys tat might be non-animatable grows, replace with Set
  if (key === "zIndex") return false;
  // If it's a number or a keyframes array, we can animate it. We might at some point
  // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
  // but for now lets leave it like this for performance reasons
  if (typeof value === "number" || Array.isArray(value)) return true;
  if (typeof value === "string" && (
  // It's animatable if we have a string
  complex.test(value) || value === "0") &&
  // And it contains numbers and/or colors
  !value.startsWith("url(") // Unless it starts with "url("
  ) {
    return true;
  }
  return false;
};

/**
 * Properties that should default to 1 or 100%
 */
var maxDefaults = new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(v) {
  var _v$slice$split = v.slice(0, -1).split("("),
    _v$slice$split2 = _slicedToArray(_v$slice$split, 2),
    name = _v$slice$split2[0],
    value = _v$slice$split2[1];
  if (name === "drop-shadow") return v;
  var _ref25 = value.match(floatRegex) || [],
    _ref26 = _slicedToArray(_ref25, 1),
    number = _ref26[0];
  if (!number) return v;
  var unit = value.replace(number, "");
  var defaultValue = maxDefaults.has(name) ? 1 : 0;
  if (number !== value) defaultValue *= 100;
  return name + "(" + defaultValue + unit + ")";
}
var functionRegex = /([a-z-]*)\(.*?\)/g;
var filter = _objectSpread(_objectSpread({}, complex), {}, {
  getAnimatableNone: function getAnimatableNone(v) {
    var functions = v.match(functionRegex);
    return functions ? functions.map(applyDefaultFilter).join(" ") : v;
  }
});

/**
 * A map of default value types for common values
 */
var defaultValueTypes = _objectSpread(_objectSpread({}, numberValueTypes), {}, {
  // Color props
  color: color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter: filter,
  WebkitFilter: filter
});
/**
 * Gets the default ValueType for the provided value key
 */
var getDefaultValueType = function getDefaultValueType(key) {
  return defaultValueTypes[key];
};
function getAnimatableNone(key, value) {
  var defaultValueType = getDefaultValueType(key);
  if (defaultValueType !== filter) defaultValueType = complex;
  // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
  return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
var isZeroValueString = function isZeroValueString(v) {
  return /^0[^.\s]+$/.test(v);
};
function isNone(value) {
  if (typeof value === "number") {
    return value === 0;
  } else if (value !== null) {
    return value === "none" || value === "0" || isZeroValueString(value);
  }
}
function getKeyframes(value, valueName, target, transition) {
  var isTargetAnimatable = isAnimatable(valueName, target);
  var keyframes;
  if (Array.isArray(target)) {
    keyframes = _toConsumableArray(target);
  } else {
    keyframes = [null, target];
  }
  var defaultOrigin = transition.from !== undefined ? transition.from : value.get();
  var animatableTemplateValue = undefined;
  var noneKeyframeIndexes = [];
  for (var i = 0; i < keyframes.length; i++) {
    /**
     * Fill null/wildcard keyframes
     */
    if (keyframes[i] === null) {
      keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
    }
    if (isNone(keyframes[i])) {
      noneKeyframeIndexes.push(i);
    }
    // TODO: Clean this conditional, it works for now
    if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") {
      animatableTemplateValue = keyframes[i];
    }
  }
  if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) {
    for (var _i = 0; _i < noneKeyframeIndexes.length; _i++) {
      var index = noneKeyframeIndexes[_i];
      keyframes[index] = getAnimatableNone(valueName, animatableTemplateValue);
    }
  }
  return keyframes;
}

/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */
function isTransitionDefined(_ref27) {
  var when = _ref27.when,
    _delay = _ref27.delay,
    delayChildren = _ref27.delayChildren,
    staggerChildren = _ref27.staggerChildren,
    staggerDirection = _ref27.staggerDirection,
    repeat = _ref27.repeat,
    repeatType = _ref27.repeatType,
    repeatDelay = _ref27.repeatDelay,
    from = _ref27.from,
    elapsed = _ref27.elapsed,
    transition = _objectWithoutProperties(_ref27, _excluded5);
  return !!Object.keys(transition).length;
}
function getValueTransition$1(transition, key) {
  return transition[key] || transition["default"] || transition;
}
var animateMotionValue = function animateMotionValue(valueName, value, target) {
  var transition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (_onComplete) {
    var valueTransition = getValueTransition$1(transition, valueName) || {};
    /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */
    var delay = valueTransition.delay || transition.delay || 0;
    /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */
    var _transition$elapsed = transition.elapsed,
      elapsed = _transition$elapsed === void 0 ? 0 : _transition$elapsed;
    elapsed = elapsed - secondsToMilliseconds(delay);
    var keyframes = getKeyframes(value, valueName, target, valueTransition);
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */
    var originKeyframe = keyframes[0];
    var targetKeyframe = keyframes[keyframes.length - 1];
    var isOriginAnimatable = isAnimatable(valueName, originKeyframe);
    var isTargetAnimatable = isAnimatable(valueName, targetKeyframe);
    exports.warning(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(valueName, " from \"").concat(originKeyframe, "\" to \"").concat(targetKeyframe, "\". ").concat(originKeyframe, " is not an animatable value - to enable this animation set ").concat(originKeyframe, " to a value animatable to ").concat(targetKeyframe, " via the `style` property."));
    var options = _objectSpread(_objectSpread({
      keyframes: keyframes,
      velocity: value.getVelocity(),
      ease: "easeOut"
    }, valueTransition), {}, {
      delay: -elapsed,
      onUpdate: function onUpdate(v) {
        value.set(v);
        valueTransition.onUpdate && valueTransition.onUpdate(v);
      },
      onComplete: function onComplete() {
        _onComplete();
        valueTransition.onComplete && valueTransition.onComplete();
      }
    });
    /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */
    if (!isTransitionDefined(valueTransition)) {
      options = _objectSpread(_objectSpread({}, options), getDefaultTransition(valueName, options));
    }
    /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */
    if (options.duration) {
      options.duration = secondsToMilliseconds(options.duration);
    }
    if (options.repeatDelay) {
      options.repeatDelay = secondsToMilliseconds(options.repeatDelay);
    }
    if (!isOriginAnimatable || !isTargetAnimatable || instantAnimationState.current || valueTransition.type === false) {
      /**
       * If we can't animate this value, or the global instant animation flag is set,
       * or this is simply defined as an instant transition, return an instant transition.
       */
      return createInstantAnimation(instantAnimationState.current ? _objectSpread(_objectSpread({}, options), {}, {
        delay: 0
      }) : options);
    }
    /**
     * Animate via WAAPI if possible.
     */
    if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
      var acceleratedAnimation = createAcceleratedAnimation(value, valueName, options);
      if (acceleratedAnimation) return acceleratedAnimation;
    }
    /**
     * If we didn't create an accelerated animation, create a JS animation
     */
    return animateValue(options);
  };
};
function isWillChangeMotionValue(value) {
  return Boolean(isMotionValue(value) && value.add);
}

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
var isNumericalString = function isNumericalString(v) {
  return /^\-?\d*\.?\d+$/.test(v);
};
function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
  var index = arr.indexOf(item);
  if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function moveItem(_ref28, fromIndex, toIndex) {
  var _ref29 = _toArray(_ref28),
    arr = _ref29.slice(0);
  var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
  if (startIndex >= 0 && startIndex < arr.length) {
    var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
    var _arr$splice = arr.splice(fromIndex, 1),
      _arr$splice2 = _slicedToArray(_arr$splice, 1),
      item = _arr$splice2[0];
    arr.splice(endIndex, 0, item);
  }
  return arr;
}
var SubscriptionManager = /*#__PURE__*/function () {
  function SubscriptionManager() {
    _classCallCheck(this, SubscriptionManager);
    this.subscriptions = [];
  }
  _createClass(SubscriptionManager, [{
    key: "add",
    value: function add(handler) {
      var _this = this;
      addUniqueItem(this.subscriptions, handler);
      return function () {
        return removeItem(_this.subscriptions, handler);
      };
    }
  }, {
    key: "notify",
    value: function notify(a, b, c) {
      var numSubscriptions = this.subscriptions.length;
      if (!numSubscriptions) return;
      if (numSubscriptions === 1) {
        /**
         * If there's only a single handler we can just call it without invoking a loop.
         */
        this.subscriptions[0](a, b, c);
      } else {
        for (var i = 0; i < numSubscriptions; i++) {
          /**
           * Check whether the handler exists before firing as it's possible
           * the subscriptions were modified during this loop running.
           */
          var handler = this.subscriptions[i];
          handler && handler(a, b, c);
        }
      }
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.subscriptions.length;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.subscriptions.length = 0;
    }
  }]);
  return SubscriptionManager;
}();
var warned = new Set();
function warnOnce(condition, message, element) {
  if (condition || warned.has(message)) return;
  console.warn(message);
  if (element) console.warn(element);
  warned.add(message);
}
var isFloat = function isFloat(value) {
  return !isNaN(parseFloat(value));
};
var collectMotionValues = {
  current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */
var MotionValue = /*#__PURE__*/function () {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  function MotionValue(init) {
    var _this2 = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, MotionValue);
    /**
     * This will be replaced by the build step with the latest version number.
     * When MotionValues are provided to motion components, warn if versions are mixed.
     */
    this.version = "10.16.4";
    /**
     * Duration, in milliseconds, since last updating frame.
     *
     * @internal
     */
    this.timeDelta = 0;
    /**
     * Timestamp of the last time this `MotionValue` was updated.
     *
     * @internal
     */
    this.lastUpdated = 0;
    /**
     * Tracks whether this value can output a velocity. Currently this is only true
     * if the value is numerical, but we might be able to widen the scope here and support
     * other value types.
     *
     * @internal
     */
    this.canTrackVelocity = false;
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    this.updateAndNotify = function (v) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      _this2.prev = _this2.current;
      _this2.current = v;
      // Update timestamp
      var delta = frameData.delta,
        timestamp = frameData.timestamp;
      if (_this2.lastUpdated !== timestamp) {
        _this2.timeDelta = delta;
        _this2.lastUpdated = timestamp;
        frame.postRender(_this2.scheduleVelocityCheck);
      }
      // Update update subscribers
      if (_this2.prev !== _this2.current && _this2.events.change) {
        _this2.events.change.notify(_this2.current);
      }
      // Update velocity subscribers
      if (_this2.events.velocityChange) {
        _this2.events.velocityChange.notify(_this2.getVelocity());
      }
      // Update render subscribers
      if (render && _this2.events.renderRequest) {
        _this2.events.renderRequest.notify(_this2.current);
      }
    };
    /**
     * Schedule a velocity check for the next frame.
     *
     * This is an instanced and bound function to prevent generating a new
     * function once per frame.
     *
     * @internal
     */
    this.scheduleVelocityCheck = function () {
      return frame.postRender(_this2.velocityCheck);
    };
    /**
     * Updates `prev` with `current` if the value hasn't been updated this frame.
     * This ensures velocity calculations return `0`.
     *
     * This is an instanced and bound function to prevent generating a new
     * function once per frame.
     *
     * @internal
     */
    this.velocityCheck = function (_ref30) {
      var timestamp = _ref30.timestamp;
      if (timestamp !== _this2.lastUpdated) {
        _this2.prev = _this2.current;
        if (_this2.events.velocityChange) {
          _this2.events.velocityChange.notify(_this2.getVelocity());
        }
      }
    };
    this.hasAnimated = false;
    this.prev = this.current = init;
    this.canTrackVelocity = isFloat(this.current);
    this.owner = options.owner;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  _createClass(MotionValue, [{
    key: "onChange",
    value: function onChange(subscription) {
      if (process.env.NODE_ENV !== "production") {
        warnOnce(false, "value.onChange(callback) is deprecated. Switch to value.on(\"change\", callback).");
      }
      return this.on("change", subscription);
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      var _this3 = this;
      if (!this.events[eventName]) {
        this.events[eventName] = new SubscriptionManager();
      }
      var unsubscribe = this.events[eventName].add(callback);
      if (eventName === "change") {
        return function () {
          unsubscribe();
          /**
           * If we have no more change listeners by the start
           * of the next frame, stop active animations.
           */
          frame.read(function () {
            if (!_this3.events.change.getSize()) {
              _this3.stop();
            }
          });
        };
      }
      return unsubscribe;
    }
  }, {
    key: "clearListeners",
    value: function clearListeners() {
      for (var eventManagers in this.events) {
        this.events[eventManagers].clear();
      }
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */
  }, {
    key: "attach",
    value: function attach(passiveEffect, stopPassiveEffect) {
      this.passiveEffect = passiveEffect;
      this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */
  }, {
    key: "set",
    value: function set(v) {
      var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!render || !this.passiveEffect) {
        this.updateAndNotify(v, render);
      } else {
        this.passiveEffect(v, this.updateAndNotify);
      }
    }
  }, {
    key: "setWithVelocity",
    value: function setWithVelocity(prev, current, delta) {
      this.set(current);
      this.prev = prev;
      this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */
  }, {
    key: "jump",
    value: function jump(v) {
      this.updateAndNotify(v);
      this.prev = v;
      this.stop();
      if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */
  }, {
    key: "get",
    value: function get() {
      if (collectMotionValues.current) {
        collectMotionValues.current.push(this);
      }
      return this.current;
    }
    /**
     * @public
     */
  }, {
    key: "getPrevious",
    value: function getPrevious() {
      return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */
  }, {
    key: "getVelocity",
    value: function getVelocity() {
      // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
      return this.canTrackVelocity ?
      // These casts could be avoided if parseFloat would be typed better
      velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */
  }, {
    key: "start",
    value: function start(startAnimation) {
      var _this4 = this;
      this.stop();
      return new Promise(function (resolve) {
        _this4.hasAnimated = true;
        _this4.animation = startAnimation(resolve);
        if (_this4.events.animationStart) {
          _this4.events.animationStart.notify();
        }
      }).then(function () {
        if (_this4.events.animationComplete) {
          _this4.events.animationComplete.notify();
        }
        _this4.clearAnimation();
      });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */
  }, {
    key: "stop",
    value: function stop() {
      if (this.animation) {
        this.animation.stop();
        if (this.events.animationCancel) {
          this.events.animationCancel.notify();
        }
      }
      this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */
  }, {
    key: "isAnimating",
    value: function isAnimating() {
      return !!this.animation;
    }
  }, {
    key: "clearAnimation",
    value: function clearAnimation() {
      delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.clearListeners();
      this.stop();
      if (this.stopPassiveEffect) {
        this.stopPassiveEffect();
      }
    }
  }]);
  return MotionValue;
}();
function motionValue(init, options) {
  return new MotionValue(init, options);
}

/**
 * Tests a provided value against a ValueType
 */
var testValueType = function testValueType(v) {
  return function (type) {
    return type.test(v);
  };
};

/**
 * ValueType for "auto"
 */
var auto = {
  test: function test(v) {
    return v === "auto";
  },
  parse: function parse(v) {
    return v;
  }
};

/**
 * A list of value types commonly used for dimensions
 */
var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */
var findDimensionValueType = function findDimensionValueType(v) {
  return dimensionValueTypes.find(testValueType(v));
};

/**
 * A list of all ValueTypes
 */
var valueTypes = [].concat(dimensionValueTypes, [color, complex]);
/**
 * Tests a value against the list of ValueTypes
 */
var findValueType = function findValueType(v) {
  return valueTypes.find(testValueType(v));
};

/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */
function setMotionValue(visualElement, key, value) {
  if (visualElement.hasValue(key)) {
    visualElement.getValue(key).set(value);
  } else {
    visualElement.addValue(key, motionValue(value));
  }
}
function setTarget(visualElement, definition) {
  var resolved = resolveVariant(visualElement, definition);
  var _ref31 = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {},
    _ref31$transitionEnd = _ref31.transitionEnd,
    transitionEnd = _ref31$transitionEnd === void 0 ? {} : _ref31$transitionEnd,
    _ref31$transition = _ref31.transition,
    transition = _ref31$transition === void 0 ? {} : _ref31$transition,
    target = _objectWithoutProperties(_ref31, _excluded6);
  target = _objectSpread(_objectSpread({}, target), transitionEnd);
  for (var _key10 in target) {
    var value = resolveFinalValueInKeyframes(target[_key10]);
    setMotionValue(visualElement, _key10, value);
  }
}
function setVariants(visualElement, variantLabels) {
  var reversedLabels = _toConsumableArray(variantLabels).reverse();
  reversedLabels.forEach(function (key) {
    var variant = visualElement.getVariant(key);
    variant && setTarget(visualElement, variant);
    if (visualElement.variantChildren) {
      visualElement.variantChildren.forEach(function (child) {
        setVariants(child, variantLabels);
      });
    }
  });
}
function setValues(visualElement, definition) {
  if (Array.isArray(definition)) {
    return setVariants(visualElement, definition);
  } else if (typeof definition === "string") {
    return setVariants(visualElement, [definition]);
  } else {
    setTarget(visualElement, definition);
  }
}
function checkTargetForNewValues(visualElement, target, origin) {
  var _a, _b;
  var newValueKeys = Object.keys(target).filter(function (key) {
    return !visualElement.hasValue(key);
  });
  var numNewValues = newValueKeys.length;
  if (!numNewValues) return;
  for (var i = 0; i < numNewValues; i++) {
    var _key11 = newValueKeys[i];
    var targetValue = target[_key11];
    var value = null;
    /**
     * If the target is a series of keyframes, we can use the first value
     * in the array. If this first value is null, we'll still need to read from the DOM.
     */
    if (Array.isArray(targetValue)) {
      value = targetValue[0];
    }
    /**
     * If the target isn't keyframes, or the first keyframe was null, we need to
     * first check if an origin value was explicitly defined in the transition as "from",
     * if not read the value from the DOM. As an absolute fallback, take the defined target value.
     */
    if (value === null) {
      value = (_b = (_a = origin[_key11]) !== null && _a !== void 0 ? _a : visualElement.readValue(_key11)) !== null && _b !== void 0 ? _b : target[_key11];
    }
    /**
     * If value is still undefined or null, ignore it. Preferably this would throw,
     * but this was causing issues in Framer.
     */
    if (value === undefined || value === null) continue;
    if (typeof value === "string" && (isNumericalString(value) || isZeroValueString(value))) {
      // If this is a number read as a string, ie "0" or "200", convert it to a number
      value = parseFloat(value);
    } else if (!findValueType(value) && complex.test(targetValue)) {
      value = getAnimatableNone(_key11, targetValue);
    }
    visualElement.addValue(_key11, motionValue(value, {
      owner: visualElement
    }));
    if (origin[_key11] === undefined) {
      origin[_key11] = value;
    }
    if (value !== null) visualElement.setBaseTarget(_key11, value);
  }
}
function getOriginFromTransition(key, transition) {
  if (!transition) return;
  var valueTransition = transition[key] || transition["default"] || transition;
  return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
  var origin = {};
  for (var _key12 in target) {
    var transitionOrigin = getOriginFromTransition(_key12, transition);
    if (transitionOrigin !== undefined) {
      origin[_key12] = transitionOrigin;
    } else {
      var value = visualElement.getValue(_key12);
      if (value) {
        origin[_key12] = value.get();
      }
    }
  }
  return origin;
}

/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */
function shouldBlockAnimation(_ref32, key) {
  var protectedKeys = _ref32.protectedKeys,
    needsAnimating = _ref32.needsAnimating;
  var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
  needsAnimating[key] = false;
  return shouldBlock;
}
function animateTarget(visualElement, definition) {
  var _ref33 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref33$delay = _ref33.delay,
    delay = _ref33$delay === void 0 ? 0 : _ref33$delay,
    transitionOverride = _ref33.transitionOverride,
    type = _ref33.type;
  var _visualElement$makeTa = visualElement.makeTargetAnimatable(definition),
    _visualElement$makeTa2 = _visualElement$makeTa.transition,
    transition = _visualElement$makeTa2 === void 0 ? visualElement.getDefaultTransition() : _visualElement$makeTa2,
    transitionEnd = _visualElement$makeTa.transitionEnd,
    target = _objectWithoutProperties(_visualElement$makeTa, _excluded7);
  var willChange = visualElement.getValue("willChange");
  if (transitionOverride) transition = transitionOverride;
  var animations = [];
  var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
  var _loop2 = function _loop2(_key13) {
    var value = visualElement.getValue(_key13);
    var valueTarget = target[_key13];
    if (!value || valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, _key13)) {
      return "continue";
    }
    var valueTransition = _objectSpread({
      delay: delay,
      elapsed: 0
    }, transition);
    /**
     * If this is the first time a value is being animated, check
     * to see if we're handling off from an existing animation.
     */
    if (window.HandoffAppearAnimations && !value.hasAnimated) {
      var appearId = visualElement.getProps()[optimizedAppearDataAttribute];
      if (appearId) {
        valueTransition.elapsed = window.HandoffAppearAnimations(appearId, _key13, value, frame);
        valueTransition.syncStart = true;
      }
    }
    value.start(animateMotionValue(_key13, value, valueTarget, visualElement.shouldReduceMotion && transformProps.has(_key13) ? {
      type: false
    } : valueTransition));
    var animation = value.animation;
    if (isWillChangeMotionValue(willChange)) {
      willChange.add(_key13);
      animation.then(function () {
        return willChange.remove(_key13);
      });
    }
    animations.push(animation);
  };
  for (var _key13 in target) {
    var _ret = _loop2(_key13);
    if (_ret === "continue") continue;
  }
  if (transitionEnd) {
    Promise.all(animations).then(function () {
      transitionEnd && setTarget(visualElement, transitionEnd);
    });
  }
  return animations;
}
var distance = function distance(a, b) {
  return Math.abs(a - b);
};
function distance2D(a, b) {
  // Multi-dimensional
  var xDelta = distance(a.x, b.x);
  var yDelta = distance(a.y, b.y);
  return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2));
}
var createAxisDelta = function createAxisDelta() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
};
var createDelta = function createDelta() {
  return {
    x: createAxisDelta(),
    y: createAxisDelta()
  };
};
var createAxis = function createAxis() {
  return {
    min: 0,
    max: 0
  };
};
var createBox = function createBox() {
  return {
    x: createAxis(),
    y: createAxis()
  };
};

/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */
function convertBoundingBoxToBox(_ref34) {
  var top = _ref34.top,
    left = _ref34.left,
    right = _ref34.right,
    bottom = _ref34.bottom;
  return {
    x: {
      min: left,
      max: right
    },
    y: {
      min: top,
      max: bottom
    }
  };
}
function convertBoxToBoundingBox(_ref35) {
  var x = _ref35.x,
    y = _ref35.y;
  return {
    top: y.min,
    right: x.max,
    bottom: y.max,
    left: x.min
  };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */
function transformBoxPoints(point, transformPoint) {
  if (!transformPoint) return point;
  var topLeft = transformPoint({
    x: point.left,
    y: point.top
  });
  var bottomRight = transformPoint({
    x: point.right,
    y: point.bottom
  });
  return {
    top: topLeft.y,
    left: topLeft.x,
    bottom: bottomRight.y,
    right: bottomRight.x
  };
}
function isIdentityScale(scale) {
  return scale === undefined || scale === 1;
}
function hasScale(_ref36) {
  var scale = _ref36.scale,
    scaleX = _ref36.scaleX,
    scaleY = _ref36.scaleY;
  return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
  return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function has2DTranslate(values) {
  return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
  return value && value !== "0%";
}

/**
 * Scales a point based on a factor and an originPoint
 */
function scalePoint(point, scale, originPoint) {
  var distanceFromOrigin = point - originPoint;
  var scaled = scale * distanceFromOrigin;
  return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
  if (boxScale !== undefined) {
    point = scalePoint(point, boxScale, originPoint);
  }
  return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */
function applyAxisDelta(axis) {
  var translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var originPoint = arguments.length > 3 ? arguments[3] : undefined;
  var boxScale = arguments.length > 4 ? arguments[4] : undefined;
  axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
  axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */
function applyBoxDelta(box, _ref37) {
  var x = _ref37.x,
    y = _ref37.y;
  applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
  applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */
function applyTreeDeltas(box, treeScale, treePath) {
  var isSharedTransition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var treeLength = treePath.length;
  if (!treeLength) return;
  // Reset the treeScale
  treeScale.x = treeScale.y = 1;
  var node;
  var delta;
  for (var i = 0; i < treeLength; i++) {
    node = treePath[i];
    delta = node.projectionDelta;
    /**
     * TODO: Prefer to remove this, but currently we have motion components with
     * display: contents in Framer.
     */
    var instance = node.instance;
    if (instance && instance.style && instance.style.display === "contents") {
      continue;
    }
    if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
      transformBox(box, {
        x: -node.scroll.offset.x,
        y: -node.scroll.offset.y
      });
    }
    if (delta) {
      // Incoporate each ancestor's scale into a culmulative treeScale for this component
      treeScale.x *= delta.x.scale;
      treeScale.y *= delta.y.scale;
      // Apply each ancestor's calculated delta into this component's recorded layout box
      applyBoxDelta(box, delta);
    }
    if (isSharedTransition && hasTransform(node.latestValues)) {
      transformBox(box, node.latestValues);
    }
  }
  /**
   * Snap tree scale back to 1 if it's within a non-perceivable threshold.
   * This will help reduce useless scales getting rendered.
   */
  treeScale.x = snapToDefault(treeScale.x);
  treeScale.y = snapToDefault(treeScale.y);
}
function snapToDefault(scale) {
  if (Number.isInteger(scale)) return scale;
  return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function translateAxis(axis, distance) {
  axis.min = axis.min + distance;
  axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */
function transformAxis(axis, transforms, _ref38) {
  var _ref39 = _slicedToArray(_ref38, 3),
    key = _ref39[0],
    scaleKey = _ref39[1],
    originKey = _ref39[2];
  var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
  var originPoint = mix(axis.min, axis.max, axisOrigin);
  // Apply the axis delta to the final axis
  applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */
function transformBox(box, transform) {
  transformAxis(box.x, transform, xKeys);
  transformAxis(box.y, transform, yKeys);
}
function measureViewportBox(instance, transformPoint) {
  return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
  var viewportBox = measureViewportBox(element, transformPagePoint);
  var scroll = rootProjectionNode.scroll;
  if (scroll) {
    translateAxis(viewportBox.x, scroll.offset.x);
    translateAxis(viewportBox.y, scroll.offset.y);
  }
  return viewportBox;
}

/**
 * Timeout defined in ms
 */
function delay(callback, timeout) {
  var start = performance.now();
  var checkElapsed = function checkElapsed(_ref40) {
    var timestamp = _ref40.timestamp;
    var elapsed = timestamp - start;
    if (elapsed >= timeout) {
      cancelFrame(checkElapsed);
      callback(elapsed - timeout);
    }
  };
  frame.read(checkElapsed, true);
  return function () {
    return cancelFrame(checkElapsed);
  };
}
function resolveElements(elements, scope, selectorCache) {
  var _a;
  if (typeof elements === "string") {
    var root = document;
    if (scope) {
      exports.invariant(Boolean(scope.current), "Scope provided, but no element detected.");
      root = scope.current;
    }
    if (selectorCache) {
      (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
      elements = selectorCache[elements];
    } else {
      elements = root.querySelectorAll(elements);
    }
  } else if (elements instanceof Element) {
    elements = [elements];
  }
  /**
   * Return an empty array
   */
  return Array.from(elements || []);
}
var visualElementStore = new WeakMap();
function observeTimeline(update, timeline) {
  var prevProgress;
  var onFrame = function onFrame() {
    var currentTime = timeline.currentTime;
    var percentage = currentTime === null ? 0 : currentTime.value;
    var progress = percentage / 100;
    if (prevProgress !== progress) {
      update(progress);
    }
    prevProgress = progress;
  };
  frame.update(onFrame, true);
  return function () {
    return cancelFrame(onFrame);
  };
}
var supportsScrollTimeline = memo(function () {
  return window.ScrollTimeline !== undefined;
});
var GroupPlaybackControls = /*#__PURE__*/function () {
  function GroupPlaybackControls(animations) {
    _classCallCheck(this, GroupPlaybackControls);
    this.animations = animations.filter(Boolean);
  }
  _createClass(GroupPlaybackControls, [{
    key: "then",
    value: function then(onResolve, onReject) {
      return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */
  }, {
    key: "getAll",
    value: function getAll(propName) {
      return this.animations[0][propName];
    }
  }, {
    key: "setAll",
    value: function setAll(propName, newValue) {
      for (var i = 0; i < this.animations.length; i++) {
        this.animations[i][propName] = newValue;
      }
    }
  }, {
    key: "attachTimeline",
    value: function attachTimeline(timeline) {
      var _this5 = this;
      var cancelAll = this.animations.map(function (animation) {
        if (supportsScrollTimeline() && animation.attachTimeline) {
          animation.attachTimeline(timeline);
        } else {
          animation.pause();
          return observeTimeline(function (progress) {
            animation.time = animation.duration * progress;
          }, timeline);
        }
      });
      return function () {
        cancelAll.forEach(function (cancelTimeline, i) {
          if (cancelTimeline) cancelTimeline();
          _this5.animations[i].stop();
        });
      };
    }
  }, {
    key: "time",
    get: function get() {
      return this.getAll("time");
    },
    set: function set(time) {
      this.setAll("time", time);
    }
  }, {
    key: "speed",
    get: function get() {
      return this.getAll("speed");
    },
    set: function set(speed) {
      this.setAll("speed", speed);
    }
  }, {
    key: "duration",
    get: function get() {
      var max = 0;
      for (var i = 0; i < this.animations.length; i++) {
        max = Math.max(max, this.animations[i].duration);
      }
      return max;
    }
  }, {
    key: "runAll",
    value: function runAll(methodName) {
      this.animations.forEach(function (controls) {
        return controls[methodName]();
      });
    }
  }, {
    key: "play",
    value: function play() {
      this.runAll("play");
    }
  }, {
    key: "pause",
    value: function pause() {
      this.runAll("pause");
    }
  }, {
    key: "stop",
    value: function stop() {
      this.runAll("stop");
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.runAll("cancel");
    }
  }, {
    key: "complete",
    value: function complete() {
      this.runAll("complete");
    }
  }]);
  return GroupPlaybackControls;
}();
function isDOMKeyframes(keyframes) {
  return typeof keyframes === "object" && !Array.isArray(keyframes);
}
function isSVGElement(element) {
  return element instanceof SVGElement && element.tagName !== "svg";
}

/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */
var splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
  var match = splitCSSVariableRegex.exec(current);
  if (!match) return [,];
  var _match = _slicedToArray(match, 3),
    token = _match[1],
    fallback = _match[2];
  return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  exports.invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"".concat(current, "\". This may indicate a circular fallback dependency."));
  var _parseCSSVariable = parseCSSVariable(current),
    _parseCSSVariable2 = _slicedToArray(_parseCSSVariable, 2),
    token = _parseCSSVariable2[0],
    fallback = _parseCSSVariable2[1];
  // No CSS variable detected
  if (!token) return;
  // Attempt to read this CSS variable off the element
  var resolved = window.getComputedStyle(element).getPropertyValue(token);
  if (resolved) {
    var trimmed = resolved.trim();
    return isNumericalString(trimmed) ? parseFloat(trimmed) : trimmed;
  } else if (isCSSVariableToken(fallback)) {
    // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return getVariableValue(fallback, element, depth + 1);
  } else {
    return fallback;
  }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */
function resolveCSSVariables(visualElement, _ref41, transitionEnd) {
  var target = Object.assign({}, (_objectDestructuringEmpty(_ref41), _ref41));
  var element = visualElement.current;
  if (!(element instanceof Element)) return {
    target: target,
    transitionEnd: transitionEnd
  };
  // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
  // only if they change but I think this reads clearer and this isn't a performance-critical path.
  if (transitionEnd) {
    transitionEnd = _objectSpread({}, transitionEnd);
  }
  // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
  visualElement.values.forEach(function (value) {
    var current = value.get();
    if (!isCSSVariableToken(current)) return;
    var resolved = getVariableValue(current, element);
    if (resolved) value.set(resolved);
  });
  // Cycle through every target property and resolve CSS variables. Currently
  // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
  for (var _key14 in target) {
    var current = target[_key14];
    if (!isCSSVariableToken(current)) continue;
    var resolved = getVariableValue(current, element);
    if (!resolved) continue;
    // Clone target if it hasn't already been
    target[_key14] = resolved;
    if (!transitionEnd) transitionEnd = {};
    // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
    // CSS variable. This will ensure that after the animation the component will reflect
    // changes in the value of the CSS variable.
    if (transitionEnd[_key14] === undefined) {
      transitionEnd[_key14] = current;
    }
  }
  return {
    target: target,
    transitionEnd: transitionEnd
  };
}
var positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y", "translateX", "translateY"]);
var isPositionalKey = function isPositionalKey(key) {
  return positionalKeys.has(key);
};
var hasPositionalKey = function hasPositionalKey(target) {
  return Object.keys(target).some(isPositionalKey);
};
var isNumOrPxType = function isNumOrPxType(v) {
  return v === number || v === px;
};
var getPosFromMatrix = function getPosFromMatrix(matrix, pos) {
  return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function getTranslateFromMatrix(pos2, pos3) {
  return function (_bbox, _ref42) {
    var transform = _ref42.transform;
    if (transform === "none" || !transform) return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
    if (matrix3d) {
      return getPosFromMatrix(matrix3d[1], pos3);
    } else {
      var matrix = transform.match(/^matrix\((.+)\)$/);
      if (matrix) {
        return getPosFromMatrix(matrix[1], pos2);
      } else {
        return 0;
      }
    }
  };
};
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformPropOrder.filter(function (key) {
  return !transformKeys.has(key);
});
function removeNonTranslationalTransform(visualElement) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function (key) {
    var value = visualElement.getValue(key);
    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  });
  // Apply changes to element before measurement
  if (removedTransforms.length) visualElement.render();
  return removedTransforms;
}
var positionalValues = {
  // Dimensions
  width: function width(_ref43, _ref44) {
    var x = _ref43.x;
    var _ref44$paddingLeft = _ref44.paddingLeft,
      paddingLeft = _ref44$paddingLeft === void 0 ? "0" : _ref44$paddingLeft,
      _ref44$paddingRight = _ref44.paddingRight,
      paddingRight = _ref44$paddingRight === void 0 ? "0" : _ref44$paddingRight;
    return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
  },
  height: function height(_ref45, _ref46) {
    var y = _ref45.y;
    var _ref46$paddingTop = _ref46.paddingTop,
      paddingTop = _ref46$paddingTop === void 0 ? "0" : _ref46$paddingTop,
      _ref46$paddingBottom = _ref46.paddingBottom,
      paddingBottom = _ref46$paddingBottom === void 0 ? "0" : _ref46$paddingBottom;
    return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
  },
  top: function top(_bbox, _ref47) {
    var _top = _ref47.top;
    return parseFloat(_top);
  },
  left: function left(_bbox, _ref48) {
    var _left = _ref48.left;
    return parseFloat(_left);
  },
  bottom: function bottom(_ref49, _ref50) {
    var y = _ref49.y;
    var top = _ref50.top;
    return parseFloat(top) + (y.max - y.min);
  },
  right: function right(_ref51, _ref52) {
    var x = _ref51.x;
    var left = _ref52.left;
    return parseFloat(left) + (x.max - x.min);
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
var convertChangedValueTypes = function convertChangedValueTypes(target, visualElement, changedKeys) {
  var originBbox = visualElement.measureViewportBox();
  var element = visualElement.current;
  var elementComputedStyle = getComputedStyle(element);
  var display = elementComputedStyle.display;
  var origin = {};
  // If the element is currently set to display: "none", make it visible before
  // measuring the target bounding box
  if (display === "none") {
    visualElement.setStaticValue("display", target.display || "block");
  }
  /**
   * Record origins before we render and update styles
   */
  changedKeys.forEach(function (key) {
    origin[key] = positionalValues[key](originBbox, elementComputedStyle);
  });
  // Apply the latest values (as set in checkAndConvertChangedValueTypes)
  visualElement.render();
  var targetBbox = visualElement.measureViewportBox();
  changedKeys.forEach(function (key) {
    // Restore styles to their **calculated computed style**, not their actual
    // originally set style. This allows us to animate between equivalent pixel units.
    var value = visualElement.getValue(key);
    value && value.jump(origin[key]);
    target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  });
  return target;
};
var checkAndConvertChangedValueTypes = function checkAndConvertChangedValueTypes(visualElement, target) {
  var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var transitionEnd = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  target = _objectSpread({}, target);
  transitionEnd = _objectSpread({}, transitionEnd);
  var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
  // We want to remove any transform values that could affect the element's bounding box before
  // it's measured. We'll reapply these later.
  var removedTransformValues = [];
  var hasAttemptedToRemoveTransformValues = false;
  var changedValueTypeKeys = [];
  targetPositionalKeys.forEach(function (key) {
    var value = visualElement.getValue(key);
    if (!visualElement.hasValue(key)) return;
    var from = origin[key];
    var fromType = findDimensionValueType(from);
    var to = target[key];
    var toType;
    // TODO: The current implementation of this basically throws an error
    // if you try and do value conversion via keyframes. There's probably
    // a way of doing this but the performance implications would need greater scrutiny,
    // as it'd be doing multiple resize-remeasure operations.
    if (isKeyframesTarget(to)) {
      var numKeyframes = to.length;
      var fromIndex = to[0] === null ? 1 : 0;
      from = to[fromIndex];
      fromType = findDimensionValueType(from);
      for (var i = fromIndex; i < numKeyframes; i++) {
        /**
         * Don't allow wildcard keyframes to be used to detect
         * a difference in value types.
         */
        if (to[i] === null) break;
        if (!toType) {
          toType = findDimensionValueType(to[i]);
          exports.invariant(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
        } else {
          exports.invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
        }
      }
    } else {
      toType = findDimensionValueType(to);
    }
    if (fromType !== toType) {
      // If they're both just number or px, convert them both to numbers rather than
      // relying on resize/remeasure to convert (which is wasteful in this situation)
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        var current = value.get();
        if (typeof current === "string") {
          value.set(parseFloat(current));
        }
        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px) {
          target[key] = to.map(parseFloat);
        }
      } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
        // If one or the other value is 0, it's safe to coerce it to the
        // type of the other without measurement
        if (from === 0) {
          value.set(toType.transform(from));
        } else {
          target[key] = fromType.transform(to);
        }
      } else {
        // If we're going to do value conversion via DOM measurements, we first
        // need to remove non-positional transform values that could affect the bbox measurements.
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform(visualElement);
          hasAttemptedToRemoveTransformValues = true;
        }
        changedValueTypeKeys.push(key);
        transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
        value.jump(to);
      }
    }
  });
  if (changedValueTypeKeys.length) {
    var scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
    var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
    // If we removed transform values, reapply them before the next render
    if (removedTransformValues.length) {
      removedTransformValues.forEach(function (_ref53) {
        var _ref54 = _slicedToArray(_ref53, 2),
          key = _ref54[0],
          value = _ref54[1];
        visualElement.getValue(key).set(value);
      });
    }
    // Reapply original values
    visualElement.render();
    // Restore scroll position
    if (isBrowser && scrollY !== null) {
      window.scrollTo({
        top: scrollY
      });
    }
    return {
      target: convertedTarget,
      transitionEnd: transitionEnd
    };
  } else {
    return {
      target: target,
      transitionEnd: transitionEnd
    };
  }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */
function unitConversion(visualElement, target, origin, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
    target: target,
    transitionEnd: transitionEnd
  };
}

/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */
var parseDomVariant = function parseDomVariant(visualElement, target, origin, transitionEnd) {
  var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
  target = resolved.target;
  transitionEnd = resolved.transitionEnd;
  return unitConversion(visualElement, target, origin, transitionEnd);
};

// Does this device prefer reduced motion? Returns `null` server-side.
var prefersReducedMotion = {
  current: null
};
var hasReducedMotionListener = {
  current: false
};
function initPrefersReducedMotion() {
  hasReducedMotionListener.current = true;
  if (!isBrowser) return;
  if (window.matchMedia) {
    var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
    var setReducedMotionPreferences = function setReducedMotionPreferences() {
      return prefersReducedMotion.current = motionMediaQuery.matches;
    };
    motionMediaQuery.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.current = false;
  }
}
function updateMotionValuesFromProps(element, next, prev) {
  var willChange = next.willChange;
  for (var _key15 in next) {
    var nextValue = next[_key15];
    var prevValue = prev[_key15];
    if (isMotionValue(nextValue)) {
      /**
       * If this is a motion value found in props or style, we want to add it
       * to our visual element's motion value map.
       */
      element.addValue(_key15, nextValue);
      if (isWillChangeMotionValue(willChange)) {
        willChange.add(_key15);
      }
      /**
       * Check the version of the incoming motion value with this version
       * and warn against mismatches.
       */
      if (process.env.NODE_ENV === "development") {
        warnOnce(nextValue.version === "10.16.4", "Attempting to mix Framer Motion versions ".concat(nextValue.version, " with 10.16.4 may not work as expected."));
      }
    } else if (isMotionValue(prevValue)) {
      /**
       * If we're swapping from a motion value to a static value,
       * create a new motion value from that
       */
      element.addValue(_key15, motionValue(nextValue, {
        owner: element
      }));
      if (isWillChangeMotionValue(willChange)) {
        willChange.remove(_key15);
      }
    } else if (prevValue !== nextValue) {
      /**
       * If this is a flat value that has changed, update the motion value
       * or create one if it doesn't exist. We only want to do this if we're
       * not handling the value with our animation state.
       */
      if (element.hasValue(_key15)) {
        var existingValue = element.getValue(_key15);
        // TODO: Only update values that aren't being animated or even looked at
        !existingValue.hasAnimated && existingValue.set(nextValue);
      } else {
        var latestValue = element.getStaticValue(_key15);
        element.addValue(_key15, motionValue(latestValue !== undefined ? latestValue : nextValue, {
          owner: element
        }));
      }
    }
  }
  // Handle removed values
  for (var _key16 in prev) {
    if (next[_key16] === undefined) element.removeValue(_key16);
  }
  return next;
}
var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
var propEventHandlers = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
var numVariantProps = variantProps.length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */
var VisualElement = /*#__PURE__*/function () {
  function VisualElement(_ref55) {
    var _this6 = this;
    var parent = _ref55.parent,
      props = _ref55.props,
      presenceContext = _ref55.presenceContext,
      reducedMotionConfig = _ref55.reducedMotionConfig,
      visualState = _ref55.visualState;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, VisualElement);
    /**
     * A reference to the current underlying Instance, e.g. a HTMLElement
     * or Three.Mesh etc.
     */
    this.current = null;
    /**
     * A set containing references to this VisualElement's children.
     */
    this.children = new Set();
    /**
     * Determine what role this visual element should take in the variant tree.
     */
    this.isVariantNode = false;
    this.isControllingVariants = false;
    /**
     * Decides whether this VisualElement should animate in reduced motion
     * mode.
     *
     * TODO: This is currently set on every individual VisualElement but feels
     * like it could be set globally.
     */
    this.shouldReduceMotion = null;
    /**
     * A map of all motion values attached to this visual element. Motion
     * values are source of truth for any given animated value. A motion
     * value might be provided externally by the component via props.
     */
    this.values = new Map();
    /**
     * Cleanup functions for active features (hover/tap/exit etc)
     */
    this.features = {};
    /**
     * A map of every subscription that binds the provided or generated
     * motion values onChange listeners to this visual element.
     */
    this.valueSubscriptions = new Map();
    /**
     * A reference to the previously-provided motion values as returned
     * from scrapeMotionValuesFromProps. We use the keys in here to determine
     * if any motion values need to be removed after props are updated.
     */
    this.prevMotionValues = {};
    /**
     * An object containing a SubscriptionManager for each active event.
     */
    this.events = {};
    /**
     * An object containing an unsubscribe function for each prop event subscription.
     * For example, every "Update" event can have multiple subscribers via
     * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
     */
    this.propEventSubscriptions = {};
    this.notifyUpdate = function () {
      return _this6.notify("Update", _this6.latestValues);
    };
    this.render = function () {
      if (!_this6.current) return;
      _this6.triggerBuild();
      _this6.renderInstance(_this6.current, _this6.renderState, _this6.props.style, _this6.projection);
    };
    this.scheduleRender = function () {
      return frame.render(_this6.render, false, true);
    };
    var latestValues = visualState.latestValues,
      renderState = visualState.renderState;
    this.latestValues = latestValues;
    this.baseTarget = _objectSpread({}, latestValues);
    this.initialValues = props.initial ? _objectSpread({}, latestValues) : {};
    this.renderState = renderState;
    this.parent = parent;
    this.props = props;
    this.presenceContext = presenceContext;
    this.depth = parent ? parent.depth + 1 : 0;
    this.reducedMotionConfig = reducedMotionConfig;
    this.options = options;
    this.isControllingVariants = isControllingVariants(props);
    this.isVariantNode = isVariantNode(props);
    if (this.isVariantNode) {
      this.variantChildren = new Set();
    }
    this.manuallyAnimateOnMount = Boolean(parent && parent.current);
    /**
     * Any motion values that are provided to the element when created
     * aren't yet bound to the element, as this would technically be impure.
     * However, we iterate through the motion values and set them to the
     * initial values for this component.
     *
     * TODO: This is impure and we should look at changing this to run on mount.
     * Doing so will break some tests but this isn't neccessarily a breaking change,
     * more a reflection of the test.
     */
    var _this$scrapeMotionVal = this.scrapeMotionValuesFromProps(props, {}),
      willChange = _this$scrapeMotionVal.willChange,
      initialMotionValues = _objectWithoutProperties(_this$scrapeMotionVal, _excluded8);
    for (var _key17 in initialMotionValues) {
      var value = initialMotionValues[_key17];
      if (latestValues[_key17] !== undefined && isMotionValue(value)) {
        value.set(latestValues[_key17], false);
        if (isWillChangeMotionValue(willChange)) {
          willChange.add(_key17);
        }
      }
    }
  }
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  _createClass(VisualElement, [{
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(_props, _prevProps) {
      return {};
    }
  }, {
    key: "mount",
    value: function mount(instance) {
      var _this7 = this;
      this.current = instance;
      visualElementStore.set(instance, this);
      if (this.projection && !this.projection.instance) {
        this.projection.mount(instance);
      }
      if (this.parent && this.isVariantNode && !this.isControllingVariants) {
        this.removeFromVariantTree = this.parent.addVariantChild(this);
      }
      this.values.forEach(function (value, key) {
        return _this7.bindToMotionValue(key, value);
      });
      if (!hasReducedMotionListener.current) {
        initPrefersReducedMotion();
      }
      this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : prefersReducedMotion.current;
      if (process.env.NODE_ENV !== "production") {
        warnOnce(this.shouldReduceMotion !== true, "You have Reduced Motion enabled on your device. Animations may not appear as expected.");
      }
      if (this.parent) this.parent.children.add(this);
      this.update(this.props, this.presenceContext);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      visualElementStore.delete(this.current);
      this.projection && this.projection.unmount();
      cancelFrame(this.notifyUpdate);
      cancelFrame(this.render);
      this.valueSubscriptions.forEach(function (remove) {
        return remove();
      });
      this.removeFromVariantTree && this.removeFromVariantTree();
      this.parent && this.parent.children.delete(this);
      for (var _key18 in this.events) {
        this.events[_key18].clear();
      }
      for (var _key19 in this.features) {
        this.features[_key19].unmount();
      }
      this.current = null;
    }
  }, {
    key: "bindToMotionValue",
    value: function bindToMotionValue(key, value) {
      var _this8 = this;
      var valueIsTransform = transformProps.has(key);
      var removeOnChange = value.on("change", function (latestValue) {
        _this8.latestValues[key] = latestValue;
        _this8.props.onUpdate && frame.update(_this8.notifyUpdate, false, true);
        if (valueIsTransform && _this8.projection) {
          _this8.projection.isTransformDirty = true;
        }
      });
      var removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
      this.valueSubscriptions.set(key, function () {
        removeOnChange();
        removeOnRenderRequest();
      });
    }
  }, {
    key: "sortNodePosition",
    value: function sortNodePosition(other) {
      /**
       * If these nodes aren't even of the same type we can't compare their depth.
       */
      if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) {
        return 0;
      }
      return this.sortInstanceNodePosition(this.current, other.current);
    }
  }, {
    key: "loadFeatures",
    value: function loadFeatures(_ref56, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
      var _this9 = this;
      var children = _ref56.children,
        renderedProps = _objectWithoutProperties(_ref56, _excluded9);
      var ProjectionNodeConstructor;
      var MeasureLayout;
      /**
       * If we're in development mode, check to make sure we're not rendering a motion component
       * as a child of LazyMotion, as this will break the file-size benefits of using it.
       */
      if (process.env.NODE_ENV !== "production" && preloadedFeatures && isStrict) {
        var strictMessage = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
        renderedProps.ignoreStrict ? exports.warning(false, strictMessage) : exports.invariant(false, strictMessage);
      }
      for (var i = 0; i < numFeatures; i++) {
        var name = featureNames[i];
        var _featureDefinitions$n = featureDefinitions[name],
          isEnabled = _featureDefinitions$n.isEnabled,
          FeatureConstructor = _featureDefinitions$n.Feature,
          ProjectionNode = _featureDefinitions$n.ProjectionNode,
          MeasureLayoutComponent = _featureDefinitions$n.MeasureLayout;
        if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
        if (isEnabled(renderedProps)) {
          if (!this.features[name] && FeatureConstructor) {
            this.features[name] = new FeatureConstructor(this);
          }
          if (MeasureLayoutComponent) {
            MeasureLayout = MeasureLayoutComponent;
          }
        }
      }
      if (!this.projection && ProjectionNodeConstructor) {
        this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
        var layoutId = renderedProps.layoutId,
          layout = renderedProps.layout,
          drag = renderedProps.drag,
          dragConstraints = renderedProps.dragConstraints,
          layoutScroll = renderedProps.layoutScroll,
          layoutRoot = renderedProps.layoutRoot;
        this.projection.setOptions({
          layoutId: layoutId,
          layout: layout,
          alwaysMeasureLayout: Boolean(drag) || dragConstraints && isRefObject(dragConstraints),
          visualElement: this,
          scheduleRender: function scheduleRender() {
            return _this9.scheduleRender();
          },
          /**
           * TODO: Update options in an effect. This could be tricky as it'll be too late
           * to update by the time layout animations run.
           * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
           * ensuring it gets called if there's no potential layout animations.
           *
           */
          animationType: typeof layout === "string" ? layout : "both",
          initialPromotionConfig: initialLayoutGroupConfig,
          layoutScroll: layoutScroll,
          layoutRoot: layoutRoot
        });
      }
      return MeasureLayout;
    }
  }, {
    key: "updateFeatures",
    value: function updateFeatures() {
      for (var _key20 in this.features) {
        var feature = this.features[_key20];
        if (feature.isMounted) {
          feature.update();
        } else {
          feature.mount();
          feature.isMounted = true;
        }
      }
    }
  }, {
    key: "triggerBuild",
    value: function triggerBuild() {
      this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */
  }, {
    key: "measureViewportBox",
    value: function measureViewportBox() {
      return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
    }
  }, {
    key: "getStaticValue",
    value: function getStaticValue(key) {
      return this.latestValues[key];
    }
  }, {
    key: "setStaticValue",
    value: function setStaticValue(key, value) {
      this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */
  }, {
    key: "makeTargetAnimatable",
    value: function makeTargetAnimatable(target) {
      var canMutate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */
  }, {
    key: "update",
    value: function update(props, presenceContext) {
      if (props.transformTemplate || this.props.transformTemplate) {
        this.scheduleRender();
      }
      this.prevProps = this.props;
      this.props = props;
      this.prevPresenceContext = this.presenceContext;
      this.presenceContext = presenceContext;
      /**
       * Update prop event handlers ie onAnimationStart, onAnimationComplete
       */
      for (var i = 0; i < propEventHandlers.length; i++) {
        var _key21 = propEventHandlers[i];
        if (this.propEventSubscriptions[_key21]) {
          this.propEventSubscriptions[_key21]();
          delete this.propEventSubscriptions[_key21];
        }
        var listener = props["on" + _key21];
        if (listener) {
          this.propEventSubscriptions[_key21] = this.on(_key21, listener);
        }
      }
      this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
      if (this.handleChildMotionValue) {
        this.handleChildMotionValue();
      }
    }
  }, {
    key: "getProps",
    value: function getProps() {
      return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */
  }, {
    key: "getVariant",
    value: function getVariant(name) {
      return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */
  }, {
    key: "getDefaultTransition",
    value: function getDefaultTransition() {
      return this.props.transition;
    }
  }, {
    key: "getTransformPagePoint",
    value: function getTransformPagePoint() {
      return this.props.transformPagePoint;
    }
  }, {
    key: "getClosestVariantNode",
    value: function getClosestVariantNode() {
      return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
  }, {
    key: "getVariantContext",
    value: function getVariantContext() {
      var startAtParent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (startAtParent) {
        return this.parent ? this.parent.getVariantContext() : undefined;
      }
      if (!this.isControllingVariants) {
        var _context = this.parent ? this.parent.getVariantContext() || {} : {};
        if (this.props.initial !== undefined) {
          _context.initial = this.props.initial;
        }
        return _context;
      }
      var context = {};
      for (var i = 0; i < numVariantProps; i++) {
        var name = variantProps[i];
        var prop = this.props[name];
        if (isVariantLabel(prop) || prop === false) {
          context[name] = prop;
        }
      }
      return context;
    }
    /**
     * Add a child visual element to our set of children.
     */
  }, {
    key: "addVariantChild",
    value: function addVariantChild(child) {
      var closestVariantNode = this.getClosestVariantNode();
      if (closestVariantNode) {
        closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
        return function () {
          return closestVariantNode.variantChildren.delete(child);
        };
      }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */
  }, {
    key: "addValue",
    value: function addValue(key, value) {
      // Remove existing value if it exists
      if (value !== this.values.get(key)) {
        this.removeValue(key);
        this.bindToMotionValue(key, value);
      }
      this.values.set(key, value);
      this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */
  }, {
    key: "removeValue",
    value: function removeValue(key) {
      this.values.delete(key);
      var unsubscribe = this.valueSubscriptions.get(key);
      if (unsubscribe) {
        unsubscribe();
        this.valueSubscriptions.delete(key);
      }
      delete this.latestValues[key];
      this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */
  }, {
    key: "hasValue",
    value: function hasValue(key) {
      return this.values.has(key);
    }
  }, {
    key: "getValue",
    value: function getValue(key, defaultValue) {
      if (this.props.values && this.props.values[key]) {
        return this.props.values[key];
      }
      var value = this.values.get(key);
      if (value === undefined && defaultValue !== undefined) {
        value = motionValue(defaultValue, {
          owner: this
        });
        this.addValue(key, value);
      }
      return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */
  }, {
    key: "readValue",
    value: function readValue(key) {
      var _a;
      return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */
  }, {
    key: "setBaseTarget",
    value: function setBaseTarget(key, value) {
      this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */
  }, {
    key: "getBaseTarget",
    value: function getBaseTarget(key) {
      var _a;
      var initial = this.props.initial;
      var valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = resolveVariantFromProps(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
      /**
       * If this value still exists in the current initial variant, read that.
       */
      if (initial && valueFromInitial !== undefined) {
        return valueFromInitial;
      }
      /**
       * Alternatively, if this VisualElement config has defined a getBaseTarget
       * so we can read the value from an alternative source, try that.
       */
      var target = this.getBaseTargetFromProps(this.props, key);
      if (target !== undefined && !isMotionValue(target)) return target;
      /**
       * If the value was initially defined on initial, but it doesn't any more,
       * return undefined. Otherwise return the value as initially read from the DOM.
       */
      return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!this.events[eventName]) {
        this.events[eventName] = new SubscriptionManager();
      }
      return this.events[eventName].add(callback);
    }
  }, {
    key: "notify",
    value: function notify(eventName) {
      if (this.events[eventName]) {
        var _this$events$eventNam;
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key22 = 1; _key22 < _len2; _key22++) {
          args[_key22 - 1] = arguments[_key22];
        }
        (_this$events$eventNam = this.events[eventName]).notify.apply(_this$events$eventNam, args);
      }
    }
  }]);
  return VisualElement;
}();
var DOMVisualElement = /*#__PURE__*/function (_VisualElement) {
  _inherits(DOMVisualElement, _VisualElement);
  var _super = _createSuper(DOMVisualElement);
  function DOMVisualElement() {
    _classCallCheck(this, DOMVisualElement);
    return _super.apply(this, arguments);
  }
  _createClass(DOMVisualElement, [{
    key: "sortInstanceNodePosition",
    value: function sortInstanceNodePosition(a, b) {
      /**
       * compareDocumentPosition returns a bitmask, by using the bitwise &
       * we're returning true if 2 in that bitmask is set to true. 2 is set
       * to true if b preceeds a.
       */
      return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
  }, {
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props.style ? props.style[key] : undefined;
    }
  }, {
    key: "removeValueFromRenderState",
    value: function removeValueFromRenderState(key, _ref57) {
      var vars = _ref57.vars,
        style = _ref57.style;
      delete vars[key];
      delete style[key];
    }
  }, {
    key: "makeTargetAnimatableFromInstance",
    value: function makeTargetAnimatableFromInstance(_ref58, _ref59, isMounted) {
      var transition = _ref58.transition,
        transitionEnd = _ref58.transitionEnd,
        target = _objectWithoutProperties(_ref58, _excluded10);
      var transformValues = _ref59.transformValues;
      var origin = getOrigin(target, transition || {}, this);
      /**
       * If Framer has provided a function to convert `Color` etc value types, convert them
       */
      if (transformValues) {
        if (transitionEnd) transitionEnd = transformValues(transitionEnd);
        if (target) target = transformValues(target);
        if (origin) origin = transformValues(origin);
      }
      if (isMounted) {
        checkTargetForNewValues(this, target, origin);
        var parsed = parseDomVariant(this, target, origin, transitionEnd);
        transitionEnd = parsed.transitionEnd;
        target = parsed.target;
      }
      return _objectSpread({
        transition: transition,
        transitionEnd: transitionEnd
      }, target);
    }
  }]);
  return DOMVisualElement;
}(VisualElement);
var SVGVisualElement = /*#__PURE__*/function (_DOMVisualElement) {
  _inherits(SVGVisualElement, _DOMVisualElement);
  var _super2 = _createSuper(SVGVisualElement);
  function SVGVisualElement() {
    var _this10;
    _classCallCheck(this, SVGVisualElement);
    _this10 = _super2.apply(this, arguments);
    _this10.isSVGTag = false;
    return _this10;
  }
  _createClass(SVGVisualElement, [{
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      return props[key];
    }
  }, {
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (transformProps.has(key)) {
        var defaultType = getDefaultValueType(key);
        return defaultType ? defaultType.default || 0 : 0;
      }
      key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
      return instance.getAttribute(key);
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox() {
      return createBox();
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props, prevProps) {
      return _scrapeMotionValuesFromProps(props, prevProps);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, options, props) {
      buildSVGAttrs(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, renderState, styleProp, projection) {
      renderSVG(instance, renderState, styleProp, projection);
    }
  }, {
    key: "mount",
    value: function mount(instance) {
      this.isSVGTag = isSVGTag(instance.tagName);
      _get(_getPrototypeOf(SVGVisualElement.prototype), "mount", this).call(this, instance);
    }
  }]);
  return SVGVisualElement;
}(DOMVisualElement);
function getComputedStyle$1(element) {
  return window.getComputedStyle(element);
}
var HTMLVisualElement = /*#__PURE__*/function (_DOMVisualElement2) {
  _inherits(HTMLVisualElement, _DOMVisualElement2);
  var _super3 = _createSuper(HTMLVisualElement);
  function HTMLVisualElement() {
    _classCallCheck(this, HTMLVisualElement);
    return _super3.apply(this, arguments);
  }
  _createClass(HTMLVisualElement, [{
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (transformProps.has(key)) {
        var defaultType = getDefaultValueType(key);
        return defaultType ? defaultType.default || 0 : 0;
      } else {
        var computedStyle = getComputedStyle$1(instance);
        var value = (isCSSVariableName(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        return typeof value === "string" ? value.trim() : value;
      }
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox(instance, _ref60) {
      var transformPagePoint = _ref60.transformPagePoint;
      return measureViewportBox(instance, transformPagePoint);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, options, props) {
      buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props, prevProps) {
      return scrapeMotionValuesFromProps$1(props, prevProps);
    }
  }, {
    key: "handleChildMotionValue",
    value: function handleChildMotionValue() {
      var _this11 = this;
      if (this.childSubscription) {
        this.childSubscription();
        delete this.childSubscription;
      }
      var children = this.props.children;
      if (isMotionValue(children)) {
        this.childSubscription = children.on("change", function (latest) {
          if (_this11.current) _this11.current.textContent = "".concat(latest);
        });
      }
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, renderState, styleProp, projection) {
      renderHTML(instance, renderState, styleProp, projection);
    }
  }]);
  return HTMLVisualElement;
}(DOMVisualElement);
function createVisualElement(element) {
  var options = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  };
  var node = isSVGElement(element) ? new SVGVisualElement(options, {
    enableHardwareAcceleration: false
  }) : new HTMLVisualElement(options, {
    enableHardwareAcceleration: true
  });
  node.mount(element);
  visualElementStore.set(element, node);
}
function animateSingleValue(value, keyframes, options) {
  var motionValue$1 = isMotionValue(value) ? value : motionValue(value);
  motionValue$1.start(animateMotionValue("", motionValue$1, keyframes, options));
  return motionValue$1.animation;
}

/**
 * Create a progress => progress easing function from a generator.
 */
function createGeneratorEasing(options) {
  var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var generator = spring(_objectSpread({
    keyframes: [0, scale]
  }, options));
  var duration = Math.min(calcGeneratorDuration(generator), maxGeneratorDuration);
  return {
    type: "keyframes",
    ease: function ease(progress) {
      return generator.next(duration * progress).value / scale;
    },
    duration: millisecondsToSeconds(duration)
  };
}

/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */
function calcNextTime(current, next, prev, labels) {
  var _a;
  if (typeof next === "number") {
    return next;
  } else if (next.startsWith("-") || next.startsWith("+")) {
    return Math.max(0, current + parseFloat(next));
  } else if (next === "<") {
    return prev;
  } else {
    return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
  }
}
var wrap = function wrap(min, max, v) {
  var rangeSize = max - min;
  return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};
function getEasingForSegment(easing, i) {
  return isEasingArray(easing) ? easing[wrap(0, easing.length, i)] : easing;
}
function eraseKeyframes(sequence, startTime, endTime) {
  for (var i = 0; i < sequence.length; i++) {
    var keyframe = sequence[i];
    if (keyframe.at > startTime && keyframe.at < endTime) {
      removeItem(sequence, keyframe);
      // If we remove this item we have to push the pointer back one
      i--;
    }
  }
}
function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
  /**
   * Erase every existing value between currentTime and targetTime,
   * this will essentially splice this timeline into any currently
   * defined ones.
   */
  eraseKeyframes(sequence, startTime, endTime);
  for (var i = 0; i < keyframes.length; i++) {
    sequence.push({
      value: keyframes[i],
      at: mix(startTime, endTime, offset[i]),
      easing: getEasingForSegment(easing, i)
    });
  }
}
function compareByTime(a, b) {
  if (a.at === b.at) {
    if (a.value === null) return 1;
    if (b.value === null) return -1;
    return 0;
  } else {
    return a.at - b.at;
  }
}
var defaultSegmentEasing = "easeInOut";
function createAnimationsFromSequence(sequence) {
  var _ref61 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref61$defaultTransit = _ref61.defaultTransition,
    defaultTransition = _ref61$defaultTransit === void 0 ? {} : _ref61$defaultTransit,
    sequenceTransition = _objectWithoutProperties(_ref61, _excluded11);
  var scope = arguments.length > 2 ? arguments[2] : undefined;
  var defaultDuration = defaultTransition.duration || 0.3;
  var animationDefinitions = new Map();
  var sequences = new Map();
  var elementCache = {};
  var timeLabels = new Map();
  var prevTime = 0;
  var currentTime = 0;
  var totalDuration = 0;
  /**
   * Build the timeline by mapping over the sequence array and converting
   * the definitions into keyframes and offsets with absolute time values.
   * These will later get converted into relative offsets in a second pass.
   */
  var _loop3 = function _loop3() {
    var segment = sequence[i];
    /**
     * If this is a timeline label, mark it and skip the rest of this iteration.
     */
    if (typeof segment === "string") {
      timeLabels.set(segment, currentTime);
      return "continue";
    } else if (!Array.isArray(segment)) {
      timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
      return "continue";
    }
    var _segment = _slicedToArray(segment, 3),
      subject = _segment[0],
      keyframes = _segment[1],
      _segment$ = _segment[2],
      transition = _segment$ === void 0 ? {} : _segment$;
    /**
     * If a relative or absolute time value has been specified we need to resolve
     * it in relation to the currentTime.
     */
    if (transition.at !== undefined) {
      currentTime = calcNextTime(currentTime, transition.at, prevTime, timeLabels);
    }
    /**
     * Keep track of the maximum duration in this definition. This will be
     * applied to currentTime once the definition has been parsed.
     */
    var maxDuration = 0;
    var resolveValueSequence = function resolveValueSequence(valueKeyframes, valueTransition, valueSequence) {
      var elementIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var numElements = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var valueKeyframesAsList = keyframesAsList(valueKeyframes);
      var _valueTransition$dela = valueTransition.delay,
        delay = _valueTransition$dela === void 0 ? 0 : _valueTransition$dela,
        _valueTransition$time = valueTransition.times,
        times = _valueTransition$time === void 0 ? defaultOffset$1(valueKeyframesAsList) : _valueTransition$time,
        _valueTransition$type = valueTransition.type,
        type = _valueTransition$type === void 0 ? "keyframes" : _valueTransition$type,
        remainingTransition = _objectWithoutProperties(valueTransition, _excluded12);
      var _valueTransition$ease = valueTransition.ease,
        ease = _valueTransition$ease === void 0 ? defaultTransition.ease || "easeOut" : _valueTransition$ease,
        duration = valueTransition.duration;
      /**
       * Resolve stagger() if defined.
       */
      var calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
      /**
       * If this animation should and can use a spring, generate a spring easing function.
       */
      var numKeyframes = valueKeyframesAsList.length;
      if (numKeyframes <= 2 && type === "spring") {
        /**
         * As we're creating an easing function from a spring,
         * ideally we want to generate it using the real distance
         * between the two keyframes. However this isn't always
         * possible - in these situations we use 0-100.
         */
        var absoluteDelta = 100;
        if (numKeyframes === 2 && isNumberKeyframesArray(valueKeyframesAsList)) {
          var delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
          absoluteDelta = Math.abs(delta);
        }
        var springTransition = _objectSpread({}, remainingTransition);
        if (duration !== undefined) {
          springTransition.duration = secondsToMilliseconds(duration);
        }
        var springEasing = createGeneratorEasing(springTransition, absoluteDelta);
        ease = springEasing.ease;
        duration = springEasing.duration;
      }
      duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
      var startTime = currentTime + calculatedDelay;
      var targetTime = startTime + duration;
      /**
       * If there's only one time offset of 0, fill in a second with length 1
       */
      if (times.length === 1 && times[0] === 0) {
        times[1] = 1;
      }
      /**
       * Fill out if offset if fewer offsets than keyframes
       */
      var remainder = times.length - valueKeyframesAsList.length;
      remainder > 0 && fillOffset(times, remainder);
      /**
       * If only one value has been set, ie [1], push a null to the start of
       * the keyframe array. This will let us mark a keyframe at this point
       * that will later be hydrated with the previous value.
       */
      valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
      /**
       * Add keyframes, mapping offsets to absolute time.
       */
      addKeyframes(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
      maxDuration = Math.max(calculatedDelay + duration, maxDuration);
      totalDuration = Math.max(targetTime, totalDuration);
    };
    if (isMotionValue(subject)) {
      var subjectSequence = getSubjectSequence(subject, sequences);
      resolveValueSequence(keyframes, transition, getValueSequence("default", subjectSequence));
    } else {
      /**
       * Find all the elements specified in the definition and parse value
       * keyframes from their timeline definitions.
       */
      var elements = resolveElements(subject, scope, elementCache);
      var numElements = elements.length;
      /**
       * For every element in this segment, process the defined values.
       */
      for (var elementIndex = 0; elementIndex < numElements; elementIndex++) {
        /**
         * Cast necessary, but we know these are of this type
         */
        keyframes = keyframes;
        transition = transition;
        var element = elements[elementIndex];
        var _subjectSequence = getSubjectSequence(element, sequences);
        for (var _key24 in keyframes) {
          resolveValueSequence(keyframes[_key24], getValueTransition(transition, _key24), getValueSequence(_key24, _subjectSequence), elementIndex, numElements);
        }
      }
      prevTime = currentTime;
      currentTime += maxDuration;
    }
  };
  for (var i = 0; i < sequence.length; i++) {
    var _ret2 = _loop3();
    if (_ret2 === "continue") continue;
  }
  /**
   * For every element and value combination create a new animation.
   */
  sequences.forEach(function (valueSequences, element) {
    for (var _key23 in valueSequences) {
      var valueSequence = valueSequences[_key23];
      /**
       * Arrange all the keyframes in ascending time order.
       */
      valueSequence.sort(compareByTime);
      var _keyframes = [];
      var valueOffset = [];
      var valueEasing = [];
      /**
       * For each keyframe, translate absolute times into
       * relative offsets based on the total duration of the timeline.
       */
      for (var _i2 = 0; _i2 < valueSequence.length; _i2++) {
        var _valueSequence$_i = valueSequence[_i2],
          at = _valueSequence$_i.at,
          value = _valueSequence$_i.value,
          easing = _valueSequence$_i.easing;
        _keyframes.push(value);
        valueOffset.push(progress(0, totalDuration, at));
        valueEasing.push(easing || "easeOut");
      }
      /**
       * If the first keyframe doesn't land on offset: 0
       * provide one by duplicating the initial keyframe. This ensures
       * it snaps to the first keyframe when the animation starts.
       */
      if (valueOffset[0] !== 0) {
        valueOffset.unshift(0);
        _keyframes.unshift(_keyframes[0]);
        valueEasing.unshift(defaultSegmentEasing);
      }
      /**
       * If the last keyframe doesn't land on offset: 1
       * provide one with a null wildcard value. This will ensure it
       * stays static until the end of the animation.
       */
      if (valueOffset[valueOffset.length - 1] !== 1) {
        valueOffset.push(1);
        _keyframes.push(null);
      }
      if (!animationDefinitions.has(element)) {
        animationDefinitions.set(element, {
          keyframes: {},
          transition: {}
        });
      }
      var definition = animationDefinitions.get(element);
      definition.keyframes[_key23] = _keyframes;
      definition.transition[_key23] = _objectSpread(_objectSpread({}, defaultTransition), {}, {
        duration: totalDuration,
        ease: valueEasing,
        times: valueOffset
      }, sequenceTransition);
    }
  });
  return animationDefinitions;
}
function getSubjectSequence(subject, sequences) {
  !sequences.has(subject) && sequences.set(subject, {});
  return sequences.get(subject);
}
function getValueSequence(name, sequences) {
  if (!sequences[name]) sequences[name] = [];
  return sequences[name];
}
function keyframesAsList(keyframes) {
  return Array.isArray(keyframes) ? keyframes : [keyframes];
}
function getValueTransition(transition, key) {
  return transition[key] ? _objectSpread(_objectSpread({}, transition), transition[key]) : _objectSpread({}, transition);
}
var isNumber = function isNumber(keyframe) {
  return typeof keyframe === "number";
};
var isNumberKeyframesArray = function isNumberKeyframesArray(keyframes) {
  return keyframes.every(isNumber);
};
function animateElements(elementOrSelector, keyframes, options, scope) {
  var elements = resolveElements(elementOrSelector, scope);
  var numElements = elements.length;
  exports.invariant(Boolean(numElements), "No valid element provided.");
  var animations = [];
  for (var i = 0; i < numElements; i++) {
    var element = elements[i];
    /**
     * Check each element for an associated VisualElement. If none exists,
     * we need to create one.
     */
    if (!visualElementStore.has(element)) {
      /**
       * TODO: We only need render-specific parts of the VisualElement.
       * With some additional work the size of the animate() function
       * could be reduced significantly.
       */
      createVisualElement(element);
    }
    var visualElement = visualElementStore.get(element);
    var transition = _objectSpread({}, options);
    /**
     * Resolve stagger function if provided.
     */
    if (typeof transition.delay === "function") {
      transition.delay = transition.delay(i, numElements);
    }
    animations.push.apply(animations, _toConsumableArray(animateTarget(visualElement, _objectSpread(_objectSpread({}, keyframes), {}, {
      transition: transition
    }), {})));
  }
  return new GroupPlaybackControls(animations);
}
var isSequence = function isSequence(value) {
  return Array.isArray(value) && Array.isArray(value[0]);
};
function animateSequence(sequence, options, scope) {
  var animations = [];
  var animationDefinitions = createAnimationsFromSequence(sequence, options, scope);
  animationDefinitions.forEach(function (_ref62, subject) {
    var keyframes = _ref62.keyframes,
      transition = _ref62.transition;
    var animation;
    if (isMotionValue(subject)) {
      animation = animateSingleValue(subject, keyframes.default, transition.default);
    } else {
      animation = animateElements(subject, keyframes, transition);
    }
    animations.push(animation);
  });
  return new GroupPlaybackControls(animations);
}
var createScopedAnimate = function createScopedAnimate(scope) {
  /**
   * Implementation
   */
  function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
    var animation;
    if (isSequence(valueOrElementOrSequence)) {
      animation = animateSequence(valueOrElementOrSequence, keyframes, scope);
    } else if (isDOMKeyframes(keyframes)) {
      animation = animateElements(valueOrElementOrSequence, keyframes, options, scope);
    } else {
      animation = animateSingleValue(valueOrElementOrSequence, keyframes, options);
    }
    if (scope) {
      scope.animations.push(animation);
    }
    return animation;
  }
  return scopedAnimate;
};
var animate = createScopedAnimate();
var resizeHandlers = new WeakMap();
var observer;
function getElementSize(target, borderBoxSize) {
  if (borderBoxSize) {
    var _borderBoxSize$ = borderBoxSize[0],
      inlineSize = _borderBoxSize$.inlineSize,
      blockSize = _borderBoxSize$.blockSize;
    return {
      width: inlineSize,
      height: blockSize
    };
  } else if (target instanceof SVGElement && "getBBox" in target) {
    return target.getBBox();
  } else {
    return {
      width: target.offsetWidth,
      height: target.offsetHeight
    };
  }
}
function notifyTarget(_ref63) {
  var target = _ref63.target,
    contentRect = _ref63.contentRect,
    borderBoxSize = _ref63.borderBoxSize;
  var _a;
  (_a = resizeHandlers.get(target)) === null || _a === void 0 ? void 0 : _a.forEach(function (handler) {
    handler({
      target: target,
      contentSize: contentRect,
      get size() {
        return getElementSize(target, borderBoxSize);
      }
    });
  });
}
function notifyAll(entries) {
  entries.forEach(notifyTarget);
}
function createResizeObserver() {
  if (typeof ResizeObserver === "undefined") return;
  observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
  if (!observer) createResizeObserver();
  var elements = resolveElements(target);
  elements.forEach(function (element) {
    var elementHandlers = resizeHandlers.get(element);
    if (!elementHandlers) {
      elementHandlers = new Set();
      resizeHandlers.set(element, elementHandlers);
    }
    elementHandlers.add(handler);
    observer === null || observer === void 0 ? void 0 : observer.observe(element);
  });
  return function () {
    elements.forEach(function (element) {
      var elementHandlers = resizeHandlers.get(element);
      elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);
      if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) {
        observer === null || observer === void 0 ? void 0 : observer.unobserve(element);
      }
    });
  };
}
var windowCallbacks = new Set();
var windowResizeHandler;
function createWindowResizeHandler() {
  windowResizeHandler = function windowResizeHandler() {
    var size = {
      width: window.innerWidth,
      height: window.innerHeight
    };
    var info = {
      target: window,
      size: size,
      contentSize: size
    };
    windowCallbacks.forEach(function (callback) {
      return callback(info);
    });
  };
  window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
  windowCallbacks.add(callback);
  if (!windowResizeHandler) createWindowResizeHandler();
  return function () {
    windowCallbacks.delete(callback);
    if (!windowCallbacks.size && windowResizeHandler) {
      windowResizeHandler = undefined;
    }
  };
}
function resize(a, b) {
  return typeof a === "function" ? resizeWindow(a) : resizeElement(a, b);
}

/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */
var maxElapsed = 50;
var createAxisInfo = function createAxisInfo() {
  return {
    current: 0,
    offset: [],
    progress: 0,
    scrollLength: 0,
    targetOffset: 0,
    targetLength: 0,
    containerLength: 0,
    velocity: 0
  };
};
var createScrollInfo = function createScrollInfo() {
  return {
    time: 0,
    x: createAxisInfo(),
    y: createAxisInfo()
  };
};
var keys = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};
function updateAxisInfo(element, axisName, info, time) {
  var axis = info[axisName];
  var _keys$axisName = keys[axisName],
    length = _keys$axisName.length,
    position = _keys$axisName.position;
  var prev = axis.current;
  var prevTime = info.time;
  axis.current = element["scroll" + position];
  axis.scrollLength = element["scroll" + length] - element["client" + length];
  axis.offset.length = 0;
  axis.offset[0] = 0;
  axis.offset[1] = axis.scrollLength;
  axis.progress = progress(0, axis.scrollLength, axis.current);
  var elapsed = time - prevTime;
  axis.velocity = elapsed > maxElapsed ? 0 : velocityPerSecond(axis.current - prev, elapsed);
}
function updateScrollInfo(element, info, time) {
  updateAxisInfo(element, "x", info, time);
  updateAxisInfo(element, "y", info, time);
  info.time = time;
}
function calcInset(element, container) {
  var inset = {
    x: 0,
    y: 0
  };
  var current = element;
  while (current && current !== container) {
    if (current instanceof HTMLElement) {
      inset.x += current.offsetLeft;
      inset.y += current.offsetTop;
      current = current.offsetParent;
    } else if (current.tagName === "svg") {
      /**
       * This isn't an ideal approach to measuring the offset of <svg /> tags.
       * It would be preferable, given they behave like HTMLElements in most ways
       * to use offsetLeft/Top. But these don't exist on <svg />. Likewise we
       * can't use .getBBox() like most SVG elements as these provide the offset
       * relative to the SVG itself, which for <svg /> is usually 0x0.
       */
      var svgBoundingBox = current.getBoundingClientRect();
      current = current.parentElement;
      var parentBoundingBox = current.getBoundingClientRect();
      inset.x += svgBoundingBox.left - parentBoundingBox.left;
      inset.y += svgBoundingBox.top - parentBoundingBox.top;
    } else if (current instanceof SVGGraphicsElement) {
      var _current$getBBox = current.getBBox(),
        x = _current$getBBox.x,
        y = _current$getBBox.y;
      inset.x += x;
      inset.y += y;
      var svg = null;
      var parent = current.parentNode;
      while (!svg) {
        if (parent.tagName === "svg") {
          svg = parent;
        }
        parent = current.parentNode;
      }
      current = svg;
    } else {
      break;
    }
  }
  return inset;
}
var ScrollOffset = {
  Enter: [[0, 1], [1, 1]],
  Exit: [[0, 0], [1, 0]],
  Any: [[1, 0], [0, 1]],
  All: [[0, 0], [1, 1]]
};
var namedEdges = {
  start: 0,
  center: 0.5,
  end: 1
};
function resolveEdge(edge, length) {
  var inset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var delta = 0;
  /**
   * If we have this edge defined as a preset, replace the definition
   * with the numerical value.
   */
  if (namedEdges[edge] !== undefined) {
    edge = namedEdges[edge];
  }
  /**
   * Handle unit values
   */
  if (typeof edge === "string") {
    var asNumber = parseFloat(edge);
    if (edge.endsWith("px")) {
      delta = asNumber;
    } else if (edge.endsWith("%")) {
      edge = asNumber / 100;
    } else if (edge.endsWith("vw")) {
      delta = asNumber / 100 * document.documentElement.clientWidth;
    } else if (edge.endsWith("vh")) {
      delta = asNumber / 100 * document.documentElement.clientHeight;
    } else {
      edge = asNumber;
    }
  }
  /**
   * If the edge is defined as a number, handle as a progress value.
   */
  if (typeof edge === "number") {
    delta = length * edge;
  }
  return inset + delta;
}
var defaultOffset = [0, 0];
function resolveOffset(offset, containerLength, targetLength, targetInset) {
  var offsetDefinition = Array.isArray(offset) ? offset : defaultOffset;
  var targetPoint = 0;
  var containerPoint = 0;
  if (typeof offset === "number") {
    /**
     * If we're provided offset: [0, 0.5, 1] then each number x should become
     * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
     * and container etc.
     */
    offsetDefinition = [offset, offset];
  } else if (typeof offset === "string") {
    offset = offset.trim();
    if (offset.includes(" ")) {
      offsetDefinition = offset.split(" ");
    } else {
      /**
       * If we're provided a definition like "100px" then we want to apply
       * that only to the top of the target point, leaving the container at 0.
       * Whereas a named offset like "end" should be applied to both.
       */
      offsetDefinition = [offset, namedEdges[offset] ? offset : "0"];
    }
  }
  targetPoint = resolveEdge(offsetDefinition[0], targetLength, targetInset);
  containerPoint = resolveEdge(offsetDefinition[1], containerLength);
  return targetPoint - containerPoint;
}
var point = {
  x: 0,
  y: 0
};
function getTargetSize(target) {
  return "getBBox" in target && target.tagName !== "svg" ? target.getBBox() : {
    width: target.clientWidth,
    height: target.clientHeight
  };
}
function resolveOffsets(container, info, options) {
  var _options$offset = options.offset,
    offsetDefinition = _options$offset === void 0 ? ScrollOffset.All : _options$offset;
  var _options$target = options.target,
    target = _options$target === void 0 ? container : _options$target,
    _options$axis = options.axis,
    axis = _options$axis === void 0 ? "y" : _options$axis;
  var lengthLabel = axis === "y" ? "height" : "width";
  var inset = target !== container ? calcInset(target, container) : point;
  /**
   * Measure the target and container. If they're the same thing then we
   * use the container's scrollWidth/Height as the target, from there
   * all other calculations can remain the same.
   */
  var targetSize = target === container ? {
    width: container.scrollWidth,
    height: container.scrollHeight
  } : getTargetSize(target);
  var containerSize = {
    width: container.clientWidth,
    height: container.clientHeight
  };
  /**
   * Reset the length of the resolved offset array rather than creating a new one.
   * TODO: More reusable data structures for targetSize/containerSize would also be good.
   */
  info[axis].offset.length = 0;
  /**
   * Populate the offset array by resolving the user's offset definition into
   * a list of pixel scroll offets.
   */
  var hasChanged = !info[axis].interpolate;
  var numOffsets = offsetDefinition.length;
  for (var i = 0; i < numOffsets; i++) {
    var offset = resolveOffset(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
    if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) {
      hasChanged = true;
    }
    info[axis].offset[i] = offset;
  }
  /**
   * If the pixel scroll offsets have changed, create a new interpolator function
   * to map scroll value into a progress.
   */
  if (hasChanged) {
    info[axis].interpolate = interpolate(info[axis].offset, defaultOffset$1(offsetDefinition));
    info[axis].interpolatorOffsets = _toConsumableArray(info[axis].offset);
  }
  info[axis].progress = info[axis].interpolate(info[axis].current);
}
function _measure(container) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : container;
  var info = arguments.length > 2 ? arguments[2] : undefined;
  /**
   * Find inset of target within scrollable container
   */
  info.x.targetOffset = 0;
  info.y.targetOffset = 0;
  if (target !== container) {
    var node = target;
    while (node && node !== container) {
      info.x.targetOffset += node.offsetLeft;
      info.y.targetOffset += node.offsetTop;
      node = node.offsetParent;
    }
  }
  info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
  info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
  info.x.containerLength = container.clientWidth;
  info.y.containerLength = container.clientHeight;
}
function createOnScrollHandler(element, onScroll, info) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    measure: function measure() {
      return _measure(element, options.target, info);
    },
    update: function update(time) {
      updateScrollInfo(element, info, time);
      if (options.offset || options.target) {
        resolveOffsets(element, info, options);
      }
    },
    notify: function notify() {
      return onScroll(info);
    }
  };
}
var scrollListeners = new WeakMap();
var resizeListeners = new WeakMap();
var onScrollHandlers = new WeakMap();
var getEventTarget = function getEventTarget(element) {
  return element === document.documentElement ? window : element;
};
function scrollInfo(onScroll) {
  var _ref64 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref64$container = _ref64.container,
    container = _ref64$container === void 0 ? document.documentElement : _ref64$container,
    options = _objectWithoutProperties(_ref64, _excluded13);
  var containerHandlers = onScrollHandlers.get(container);
  /**
   * Get the onScroll handlers for this container.
   * If one isn't found, create a new one.
   */
  if (!containerHandlers) {
    containerHandlers = new Set();
    onScrollHandlers.set(container, containerHandlers);
  }
  /**
   * Create a new onScroll handler for the provided callback.
   */
  var info = createScrollInfo();
  var containerHandler = createOnScrollHandler(container, onScroll, info, options);
  containerHandlers.add(containerHandler);
  /**
   * Check if there's a scroll event listener for this container.
   * If not, create one.
   */
  if (!scrollListeners.has(container)) {
    var measureAll = function measureAll() {
      var _iterator = _createForOfIteratorHelper(containerHandlers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var handler = _step.value;
          handler.measure();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    var updateAll = function updateAll() {
      var _iterator2 = _createForOfIteratorHelper(containerHandlers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var handler = _step2.value;
          handler.update(frameData.timestamp);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };
    var _notifyAll = function _notifyAll() {
      var _iterator3 = _createForOfIteratorHelper(containerHandlers),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var handler = _step3.value;
          handler.notify();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };
    var _listener = function _listener() {
      frame.read(measureAll, false, true);
      frame.update(updateAll, false, true);
      frame.update(_notifyAll, false, true);
    };
    scrollListeners.set(container, _listener);
    var target = getEventTarget(container);
    window.addEventListener("resize", _listener, {
      passive: true
    });
    if (container !== document.documentElement) {
      resizeListeners.set(container, resize(container, _listener));
    }
    target.addEventListener("scroll", _listener, {
      passive: true
    });
  }
  var listener = scrollListeners.get(container);
  frame.read(listener, false, true);
  return function () {
    var _a;
    cancelFrame(listener);
    /**
     * Check if we even have any handlers for this container.
     */
    var currentHandlers = onScrollHandlers.get(container);
    if (!currentHandlers) return;
    currentHandlers.delete(containerHandler);
    if (currentHandlers.size) return;
    /**
     * If no more handlers, remove the scroll listener too.
     */
    var scrollListener = scrollListeners.get(container);
    scrollListeners.delete(container);
    if (scrollListener) {
      getEventTarget(container).removeEventListener("scroll", scrollListener);
      (_a = resizeListeners.get(container)) === null || _a === void 0 ? void 0 : _a();
      window.removeEventListener("resize", scrollListener);
    }
  };
}
function scrollTimelineFallback(_ref65) {
  var source = _ref65.source,
    _ref65$axis = _ref65.axis,
    axis = _ref65$axis === void 0 ? "y" : _ref65$axis;
  // ScrollTimeline records progress as a percentage CSSUnitValue
  var currentTime = {
    value: 0
  };
  var cancel = scrollInfo(function (info) {
    currentTime.value = info[axis].progress * 100;
  }, {
    container: source,
    axis: axis
  });
  return {
    currentTime: currentTime,
    cancel: cancel
  };
}
var timelineCache = new Map();
function getTimeline() {
  var _ref66 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref66$source = _ref66.source,
    source = _ref66$source === void 0 ? document.documentElement : _ref66$source,
    _ref66$axis = _ref66.axis,
    axis = _ref66$axis === void 0 ? "y" : _ref66$axis;
  if (!timelineCache.has(source)) {
    timelineCache.set(source, {});
  }
  var elementCache = timelineCache.get(source);
  if (!elementCache[axis]) {
    elementCache[axis] = supportsScrollTimeline() ? new ScrollTimeline({
      source: source,
      axis: axis
    }) : scrollTimelineFallback({
      source: source,
      axis: axis
    });
  }
  return elementCache[axis];
}
function scroll(onScroll, options) {
  var timeline = getTimeline(options);
  if (typeof onScroll === "function") {
    return observeTimeline(onScroll, timeline);
  } else {
    return onScroll.attachTimeline(timeline);
  }
}
var thresholds = {
  some: 0,
  all: 1
};
function inView(elementOrSelector, onStart) {
  var _ref67 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    root = _ref67.root,
    rootMargin = _ref67.margin,
    _ref67$amount = _ref67.amount,
    amount = _ref67$amount === void 0 ? "some" : _ref67$amount;
  var elements = resolveElements(elementOrSelector);
  var activeIntersections = new WeakMap();
  var onIntersectionChange = function onIntersectionChange(entries) {
    entries.forEach(function (entry) {
      var onEnd = activeIntersections.get(entry.target);
      /**
       * If there's no change to the intersection, we don't need to
       * do anything here.
       */
      if (entry.isIntersecting === Boolean(onEnd)) return;
      if (entry.isIntersecting) {
        var newOnEnd = onStart(entry);
        if (typeof newOnEnd === "function") {
          activeIntersections.set(entry.target, newOnEnd);
        } else {
          observer.unobserve(entry.target);
        }
      } else if (onEnd) {
        onEnd(entry);
        activeIntersections.delete(entry.target);
      }
    });
  };
  var observer = new IntersectionObserver(onIntersectionChange, {
    root: root,
    rootMargin: rootMargin,
    threshold: typeof amount === "number" ? amount : thresholds[amount]
  });
  elements.forEach(function (element) {
    return observer.observe(element);
  });
  return function () {
    return observer.disconnect();
  };
}
function getOriginIndex(from, total) {
  if (from === "first") {
    return 0;
  } else {
    var lastIndex = total - 1;
    return from === "last" ? lastIndex : lastIndex / 2;
  }
}
function stagger() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.1;
  var _ref68 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref68$startDelay = _ref68.startDelay,
    startDelay = _ref68$startDelay === void 0 ? 0 : _ref68$startDelay,
    _ref68$from = _ref68.from,
    from = _ref68$from === void 0 ? 0 : _ref68$from,
    ease = _ref68.ease;
  return function (i, total) {
    var fromIndex = typeof from === "number" ? from : getOriginIndex(from, total);
    var distance = Math.abs(fromIndex - i);
    var delay = duration * distance;
    if (ease) {
      var maxDelay = total * duration;
      var easingFunction = easingDefinitionToFunction(ease);
      delay = easingFunction(delay / maxDelay) * maxDelay;
    }
    return startDelay + delay;
  };
}
var isCustomValueType = function isCustomValueType(v) {
  return typeof v === "object" && v.mix;
};
var getMixer = function getMixer(v) {
  return isCustomValueType(v) ? v.mix : undefined;
};
function transform() {
  var useImmediate = !Array.isArray(arguments.length <= 0 ? undefined : arguments[0]);
  var argOffset = useImmediate ? 0 : -1;
  var inputValue = 0 + argOffset < 0 || arguments.length <= 0 + argOffset ? undefined : arguments[0 + argOffset];
  var inputRange = 1 + argOffset < 0 || arguments.length <= 1 + argOffset ? undefined : arguments[1 + argOffset];
  var outputRange = 2 + argOffset < 0 || arguments.length <= 2 + argOffset ? undefined : arguments[2 + argOffset];
  var options = 3 + argOffset < 0 || arguments.length <= 3 + argOffset ? undefined : arguments[3 + argOffset];
  var interpolator = interpolate(inputRange, outputRange, _objectSpread({
    mixer: getMixer(outputRange[0])
  }, options));
  return useImmediate ? interpolator(inputValue) : interpolator;
}

/**
 * @deprecated
 *
 * Import as `frame` instead.
 */
var sync = frame;
/**
 * @deprecated
 *
 * Use cancelFrame(callback) instead.
 */
var cancelSync = stepsOrder.reduce(function (acc, key) {
  acc[key] = function (process) {
    return cancelFrame(process);
  };
  return acc;
}, {});
exports.HTMLVisualElement = HTMLVisualElement;
exports.MotionValue = MotionValue;
exports.SVGVisualElement = SVGVisualElement;
exports.SubscriptionManager = SubscriptionManager;
exports.VisualElement = VisualElement;
exports.addScaleCorrector = addScaleCorrector;
exports.addUniqueItem = addUniqueItem;
exports.animate = animate;
exports.animateMotionValue = animateMotionValue;
exports.animateSingleValue = animateSingleValue;
exports.animateStyle = animateStyle;
exports.animateTarget = animateTarget;
exports.animateValue = animateValue;
exports.anticipate = anticipate;
exports.applyBoxDelta = applyBoxDelta;
exports.applyTreeDeltas = applyTreeDeltas;
exports.backIn = backIn;
exports.backInOut = backInOut;
exports.backOut = backOut;
exports.buildHTMLStyles = buildHTMLStyles;
exports.buildSVGAttrs = buildSVGAttrs;
exports.buildTransform = buildTransform;
exports.camelToDash = camelToDash;
exports.cancelFrame = cancelFrame;
exports.cancelSync = cancelSync;
exports.checkTargetForNewValues = checkTargetForNewValues;
exports.circIn = circIn;
exports.circInOut = circInOut;
exports.circOut = circOut;
exports.clamp = clamp;
exports.collectMotionValues = collectMotionValues;
exports.color = color;
exports.complex = complex;
exports.convertBoundingBoxToBox = convertBoundingBoxToBox;
exports.convertBoxToBoundingBox = convertBoxToBoundingBox;
exports.createBox = createBox;
exports.createDelta = createDelta;
exports.createScopedAnimate = createScopedAnimate;
exports.cubicBezier = cubicBezier;
exports.delay = delay;
exports.distance = distance;
exports.distance2D = distance2D;
exports.easeIn = easeIn;
exports.easeInOut = easeInOut;
exports.easeOut = easeOut;
exports.featureDefinitions = featureDefinitions;
exports.frame = frame;
exports.frameData = frameData;
exports.getOrigin = getOrigin;
exports.getValueTransition = getValueTransition$1;
exports.has2DTranslate = has2DTranslate;
exports.hasReducedMotionListener = hasReducedMotionListener;
exports.hasScale = hasScale;
exports.hasTransform = hasTransform;
exports.inView = inView;
exports.initPrefersReducedMotion = initPrefersReducedMotion;
exports.instantAnimationState = instantAnimationState;
exports.interpolate = interpolate;
exports.isAnimationControls = isAnimationControls;
exports.isBrowser = isBrowser;
exports.isCSSVariableName = isCSSVariableName;
exports.isControllingVariants = isControllingVariants;
exports.isCustomValue = isCustomValue;
exports.isForcedMotionValue = isForcedMotionValue;
exports.isKeyframesTarget = isKeyframesTarget;
exports.isMotionValue = isMotionValue;
exports.isRefObject = isRefObject;
exports.isSVGElement = isSVGElement;
exports.isSVGTag = isSVGTag;
exports.isVariantLabel = isVariantLabel;
exports.isVariantNode = isVariantNode;
exports.measurePageBox = measurePageBox;
exports.millisecondsToSeconds = millisecondsToSeconds;
exports.mirrorEasing = mirrorEasing;
exports.mix = mix;
exports.motionValue = motionValue;
exports.moveItem = moveItem;
exports.noop = noop;
exports.optimizedAppearDataAttribute = optimizedAppearDataAttribute;
exports.optimizedAppearDataId = optimizedAppearDataId;
exports.percent = percent;
exports.pipe = pipe;
exports.prefersReducedMotion = prefersReducedMotion;
exports.progress = progress;
exports.px = px;
exports.removeItem = removeItem;
exports.renderSVG = renderSVG;
exports.resolveVariant = resolveVariant;
exports.resolveVariantFromProps = resolveVariantFromProps;
exports.reverseEasing = reverseEasing;
exports.scaleCorrectors = scaleCorrectors;
exports.scalePoint = scalePoint;
exports.scrapeMotionValuesFromProps = _scrapeMotionValuesFromProps;
exports.scrapeMotionValuesFromProps$1 = scrapeMotionValuesFromProps$1;
exports.scroll = scroll;
exports.scrollInfo = scrollInfo;
exports.secondsToMilliseconds = secondsToMilliseconds;
exports.setValues = setValues;
exports.spring = spring;
exports.stagger = stagger;
exports.steps = steps;
exports.sync = sync;
exports.transform = transform;
exports.transformBox = transformBox;
exports.transformProps = transformProps;
exports.translateAxis = translateAxis;
exports.variantPriorityOrder = variantPriorityOrder;
exports.visualElementStore = visualElementStore;
exports.warnOnce = warnOnce;
exports.wrap = wrap;